import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

/**缴费通知单**/
import WxPay from '../views/pages/wechat/WxPay'
/**租控图**/
import Leasing from '../views/pages/wechat/Leasing'

import InvoiceLogin from '../views/pages/invoice/login'
import Invoice from '../views/pages/invoice/index'
import List from '../views/pages/invoice/list'
import InvoiceList from '../views/pages/invoice/invoiceList'
import InvoiceInfo from '../views/pages/invoice/invoiceInfo'
import InvoiceDetail from '../views/pages/invoice/invoiceDetail'
import InvoiceInfoDetail from '../views/pages/invoice/invoiceInfoDetail'
import expenseSelect from "../views/pages/invoice/expenseSelect";

import home from '../views/home.vue'
import refund from '../views/pages/refund.vue'
import derated from '../views/pages/derated.vue'
import plan from '../views/pages/plan.vue'
import route from '../views/pages/route.vue'
import qualityplan from '../views/pages/qualityplan.vue'
import equipmentAnnualInspection from '../views/pages/equipmentAnnualInspection.vue'
import equipmentMaintenance from '../views/pages/equipmentMaintenance.vue'
import qualityTask from '../views/pages/qualityTask.vue'
import decorateInfo from '../views/pages/decorate.vue'
import decorateWaterproof from "../views/pages/decorateWaterproof";
import decorateAcceptance from "../views/pages/decorateAcceptance";
import decorateWaterproofView from "../views/pages/decorateWaterproofView";
import qualityRectify from '../views/pages/qualityRectify.vue'
import CommunityConsultation from '../views/pages/CommunityConsultation.vue'
import notice from '../views/pages/notice.vue'
import archiveInfo from '../views/pages/archiveInfo.vue'
import archiveType from '../views/pages/archiveType.vue'
import extensionBid from '../views/pages/extensionBid.vue'
import extensionSurvey from '../views/pages/extensionSurvey.vue'
import handoverDoc from '../views/pages/handoverDoc.vue'
import handoverWithdrawal from '../views/pages/handoverWithdrawal.vue'

import infacyProjectReception from '../views/pages/infacyProjectReception.vue'

import businessUnitInfo from '../views/pages/BusinessUnitInfo'
import DoubleRandomCheckManagement from "../views/pages/DoubleRandomCheckManagement";
import EmergencyHandling from "../views/pages/EmergencyHandling";
import equipmentInfoFile from "../views/pages/equipmentInfoFile";
import EquipmentInspectionPlan from "../views/pages/EquipmentInspectionPlan";
import QualityInspectionStandard from "../views/pages/QualityInspectionStandard";
import ReceiptManagement from "../views/pages/ReceiptManagement";
import WuYeNoticeManagement from "../views/pages/WuYeNoticeManagement";
import wuyeProjectInfo from "../views/pages/wuyeProjectInfo";
import houseType from "../views/pages/houseType";
import customerType from "../views/pages/customerType"
import feeItem from '../views/pages/feeItem.vue';
import feeNorm from '../views/pages/feeNorm.vue';
import baseCar from '../views/pages/baseCar.vue';
import customerProject from '../views/pages/customerProject.vue';
import orderHandover from '../views/pages/orderHandover.vue';
import orderMonitor from '../views/pages/orderMonitor.vue';
import baseBuilding from '../views/pages/baseBuilding.vue';
import plDerated from "../views/pages/plDerated";
import plDeratedDetail from "../views/pages/plDeratedDetail";
import inputBasisInfo from "../views/pages/inputBasisInfo";
import contractDerated from "../views/pages/contract/derated";
import contractContracts from "../views/pages/contract/contracts";
import contractView from '../views/pages/contract/contractView.vue';
import contractInfo from "../views/pages/contract/contractInfo";
import contractChange from "../views/pages/contract/contractChange";
import property from "../views/pages/contract/property";
import marchInto from "../views/pages/contract/marchInto";
import marchIntoDetail from "../views/pages/contract/marchIntoDetail";
import marchOut from "../views/pages/contract/marchOut";
import marchOutDetail from "../views/pages/contract/marchOutDetail";
import marchOutFeeDetail from "../views/pages/contract/marchOutFeeDetail";
import retention from "../views/pages/contract/retention";
import customer from "../views/pages/contract/customer";
import customerDetail from "../views/pages/contract/customerDetail";
import brand from "../views/pages/contract/brand";
import market from "../views/pages/contract/market";
import lease from "../views/pages/contract/lease";
import leaseDetail from "../views/pages/contract/leaseDetail";
import switchRoom from "../views/pages/contract/switchRoom";
import shyedecorateRectify from "../views/pages/contract/decorateRectify";
import shyedecorateGarbageClear from "../views/pages/contract/decorateGarbageClear";
import buildGarbageClear from "../views/pages/contract/buildGarbageClear";
import custserv from "../views/pages/contract/custserv";
import shyecomplaint from "../views/pages/contract/complaint";
import shyemaintain from "../views/pages/contract/maintain";

import resources from "../views/pages/contract/resources";
import unitPrice from "../views/pages/contract/unitPrice";
import adjust from "../views/pages/contract/adjust";
import staging from "../views/pages/contract/staging";
import greenPlan from "../views/pages/contract/greenPlan";
import greenReseed from "../views/pages/contract/greenReseed";
import baseHouse from "../views/pages/baseHouse";
import meterChange from "../views/pages/meterChange";
import meterInfo from "../views/pages/meterInfo";
import meterType from "../views/pages/meterType";
import projectPhotoType from "../views/pages/projectPhotoType";
import financeHandoverDoc from "../views/pages/financeHandoverDoc";
import generalTemplate from "../views/pages/generalTemplate";
import projectPhoto from "../views/pages/projectPhoto";
import generalTemplateCategory from "../views/pages/generalTemplateCategory";
import giftSetting from "../views/pages/giftSetting";
import decorateRectify from "../views/pages/decorateRectify";
import decorateGarbageClear from "../views/pages/decorateGarbageClear";
import baseCustServReport from "../views/pages/baseCustServReport";
import complaint from "../views/pages/complaint";
import maintain from "../views/pages/maintain";
import knowType from "../views/pages/knowType";
import deliveryInfo from "../views/pages/deliveryInfo";
import customerListInfo from "../views/pages/customerListInfo";
import feeItemInfo from "../views/pages/feeItemInfo";
import banner from "../views/pages/banner";
import noticeDetail from "../views/pages/noticeDetail";
import smallSurround from "../views/pages/smallSurround";
import fireFighting from "../views/pages/fireFighting";
import virescene from "../views/pages/virescene";
// import houseHoldAcceptance from "../views/pages/houseHoldAcceptance";
// import buildingInspection from "../views/pages/buildingInspection";
// import undertakeInspection from "../views/pages/undertakeInspection";
import inspectionRectify from "../views/pages/inspectionRectify";
import flowableIndex from '../views/pages/flowable/index'
import login from '../views/login'
import materHome from '../views/materHome'
import applybill from "../views/pages/mater/applybill";
import applybillDerated from "../views/pages/mater/applybillDetail";
import contract from "../views/pages/mater/contract";
import materContractDerated from "../views/pages/mater/contractDetail";
import putstore from "../views/pages/mater/putstore";
import putstoreDerated from "../views/pages/mater/putstoreDetail";
import receipt from "../views/pages/mater/receipt";
import receiptReceInvosDerated from "../views/pages/mater/receiptReceInvosDerated";
import receiptReceivingSubsDerated from "../views/pages/mater/receiptReceivingSubsDerated";
import delivery from "../views/pages/mater/delivery";
import deliveryDerated from "../views/pages/mater/deliveryDetail";
import picking from "../views/pages/mater/picking";
import pickingDerated from "../views/pages/mater/pickingDetail";
import contractAdjust from "../views/pages/mater/contractAdjust";
import contractAdjustDerated from "../views/pages/mater/contractAdjustDetail";
import budget from "../views/pages/mater/budget";
import budgetDerated from "../views/pages/mater/budgetDetail";
import budgetAdjust from "../views/pages/mater/budgetAdjust";
import budgetAdjustDerated from "../views/pages/mater/budgetAdjustDetail";
import supplierBudget from "../views/pages/mater/supplierBudget";
import supplierBudgetDerated from "../views/pages/mater/supplierBudgetDetail";
import supplierBudgetAdjust from "../views/pages/mater/supplierBudgetAdjust";
import supplierBudgetAdjustDerated from "../views/pages/mater/supplierBudgetAdjustDetail";
import contractMaterAdjust from "../views/pages/mater/contractMaterAdjust";
import contractMaterAdjustDerated from "../views/pages/mater/contractMaterAdjustDetail";
import knowInfo from "../views/pages/knowInfo";
import CustomerMarch from "../views/pages/wuye/CustomerMarch";
import equipmentSignLabel from "../views/pages/equipmentSignLabel.vue";
import equipmentSignLabelApply from "../views/pages/equipmentSignLabelApply.vue";
// import invoice from "../views/pages/mater/invoice";
// import invoiceDerated from "../views/pages/mater/invoiceDetail";
import supplierInfo from "../views/pages/cost/supplier/supplierInfo";
import budgetPreparation from "../views/pages/cost/budgetPreparation/budgetPreparation";
import budgetPreparationDetail from "../views/pages/cost/budgetPreparation/budgetPreparationDetail";
import budgetPreparationAdjust from "../views/pages/cost/budgetPreparation/budgetPreparationAdjust";
import budgetPreparationAdjustDetail from "../views/pages/cost/budgetPreparation/budgetPreparationAdjustDetail";
import costContract from '../views/pages/cost/contract/contract'
import contractAdjustPayment from "../views/pages/cost/contract/contractAdjustPayment";
import contractWorkloadEstimate from "../views/pages/cost/contract/contractWorkloadEstimate";
import contractWorkloadEstimateDetail from "../views/pages/cost/contract/contractWorkloadEstimateDetail";
import eventWorkloadEstimateDetail from '../views/pages/cost/event/eventWorkloadEstimateDetail'
import costEvent from '../views/pages/cost/event/event'
import costRequestFunds from '../views/pages/cost/requestFunds/costRequestFunds'
import costClaimDetailTable from '../views/pages/cost/claim/detailTable'
import costClaimTravelDetailTable from '../views/pages/cost/claim/travelDetailTable'
import costPaymentRequestReserveFunds from '../views/pages/cost/payment/requestReserveFunds'
import contractSettlement from "../views/pages/cost/contract/contractSettlement";
import contractWarranty from "../views/pages/cost/contract/contractWarranty";
import contractDeduction from "../views/pages/cost/contract/contractDeduction";
import eventAdjust from "../views/pages/cost/event/eventAdjust.vue";
import invoiceFlow from "../views/pages/cost/invoice/invoiceFlow.vue";
import vatInvoiceDetail from "../views/pages/cost/invoice/vatInvoiceDetail.vue";
import agInvoiceDetail from "@/views/pages/cost/invoice/agInvoiceDetail.vue";
// import hrDemo from "../views/pages/hr/demo/demo.vue";
// import hrHireRegistSchool from "../views/pages/hr/hire/regist/hireRegistSchool.vue"
// import hrHireRegistWeb from "../views/pages/hr/hire/regist/hireRegistWeb.vue"
// import hrHireRegistWork from "../views/pages/hr/hire/regist/hireRegistWork.vue"
// import hrHireRegistPlan from "../views/pages/hr/hire/regist/hireRegistPlan.vue";

import tztj from "../views/pages/cost/sfkh/Tztj";
import decompose from "../views/pages/cost/sfkh/decompose";

// 会签审批单页面
import newContract from "../views/pages/hq/leasing/contract/newContract.vue";
import contractRenew from "../views/pages/hq/leasing/contract/contractRenew.vue";
import newAdvertisement from "../views/pages/hq/leasing/advertisement/newAdvertisement.vue";
import advertisementRenew from "../views/pages/hq/leasing/advertisement/advertisementRenew.vue";
import contractChange2 from "../views/pages/hq/leasing/contractChange/contractChange.vue"
import feePlan from "../views/pages/hq/leasing/feePlan/feePlan.vue";
import chargeIndexAdjust from "../views/pages/hq/leasing/revenue/chargeIndexAdjust.vue";
import internalSettlement from "../views/pages/hq/leasing/revenue/internalSettlement.vue";
import parkingFeeReduce from "../views/pages/hq/leasing/revenue/parkingFeeReduce.vue";
import refund2 from "../views/pages/hq/leasing/revenue/refund.vue";
import wuyeFeeReduce from "../views/pages/hq/leasing/revenue/wuyeFeeReduce.vue";
import comparePrice from "../views/pages/hq/spend/comparePrice/comparePrice.vue";
import commission from "../views/pages/hq/spend/contract/commission.vue";
import materialPurchase from "../views/pages/hq/spend/contract/materialPurchase.vue";
import advertiseMake from "../views/pages/hq/spend/extra/advertiseMake.vue";
import advertisePromotion from "../views/pages/hq/spend/extra/advertisePromotion.vue";
import clear2 from "../views/pages/hq/spend/extra/clear.vue";
import dailyMaintenance from "../views/pages/hq/spend/extra/dailyMaintenance.vue";
import machineryLeasing from "../views/pages/hq/spend/extra/machineryLeasing.vue";
import machineryLeasingDetail from "../views/pages/hq/spend/extra/machineryLeasingDetail.vue";
import maintenance from "../views/pages/hq/spend/extra/maintenance.vue";
import lxcg from "../views/pages/hq/spend/lxcg/lxcg.vue";
import lxcgDetail from "../views/pages/hq/spend/lxcg/lxcgDetail.vue";
import other2 from "../views/pages/hq/spend/contract/other.vue";
import LxzcOther2 from "../views/pages/hq/spend/lxzc/lxzcOther.vue";
import methodPrice from "../views/pages/hq/spend/methodPrice/methodPrice.vue";
import methodPriceDetail from "../views/pages/hq/spend/methodPrice/methodPriceDetail.vue";
import projectCredits from "../views/pages/hq/spend/projectCredits/projectCredits.vue";
import projectCreditsDetail from "../views/pages/hq/spend/projectCredits/projectCreditsDetail.vue";
import engineer from "../views/pages/hq/spend/projectSign/engineer.vue";
import repairRetrofit from "../views/pages/hq/spend/projectSign/repairRetrofit.vue";
import hqGeneral from "../views/pages/hq/other/hqGeneral.vue";
import gcsg from "../views/pages/hq/spend/contract/gcsg.vue";
import hqDisposalItems from "../views/pages/hq/leasing/fee/hqDisposalItems.vue";
import hqSalesContract from "../views/pages/hq/sales/Contract.vue";
//合同管理
import ContractType from "../views/pages/erp/contract/base/ContractType.vue";
import ContractFormat from "../views/pages/erp/contract/base/ContractFormat.vue";
import ContractMust from "../views/pages/erp/contract/base/ContractMust.vue";
import ContractSignRole from "../views/pages/erp/contract/base/ContractSignRole.vue";
import ContractSafeKeep from "../views/pages/erp/contract/base/ContractSafeKeep.vue";
import ContractCirculationApproval from "../views/pages/erp/contract/info/ContractCirculationApproval.vue";
import ContractHqApproval from "../views/pages/erp/contract/info/ContractHqApproval.vue";
import ContractNewInner from "../views/pages/erp/contract/info/ContractNewInner.vue";
import ContractNewTemplate from "../views/pages/erp/contract/info/ContractNewTemplate.vue";
import ContractUse from "../views/pages/erp/contract/info/ContractUse.vue";
import ContractDispute from "../views/pages/erp/contract/info/ContractDispute.vue";


// 零星工程审批页面
import startInfo from "../views/pages/lxgc/startInfo.vue";
import minorRepair from "../views/pages/lxgc/minorRepair.vue";
import completionAcceptance from "../views/pages/lxgc/completionAcceptance.vue";
import completionSettlement from "../views/pages/lxgc/completionSettlement.vue";
import completionSettlementDetail from "../views/pages/lxgc/completionSettlementDetail.vue";
import contractPartyJiaConfirm from "../views/pages/lxgc/contractPartyJiaConfirm.vue";
import contractPartyJiaConfirmDetail from "../views/pages/lxgc/contractPartyJiaConfirmDetail.vue";


const routes = [
    {
        path: '/login',
        component: login
    },
    {
        path: "/wxPay",
        component: WxPay,
        meta: {title: '缴费通知单'}
    },
    {
        path: "/leasing",
        component: Leasing,
        meta: {title: '租控图'}
    },
    {
        path: "/invoiceLogin",
        component: InvoiceLogin,
        meta: {title: '发票'}
    },
    {
        path: "/invoice",
        component: Invoice,
        meta: {title: '发票'}
    },
    {
        path: "/list",
        component: List,
        meta: {title: '报销单'}
    },
    {
        path: "/invoiceList",
        component: InvoiceList,
        meta: {title: '识别列表'}
    },
    {
        path: "/invoiceInfo",
        component: InvoiceInfo,
        meta: {title: '发票信息'}
    },
    {
        path: "/invoiceDetail",
        component: InvoiceDetail,
        meta: {title: '发票明细详情'}
    },
    {
        path: "/invoiceInfoDetail",
        component: InvoiceInfoDetail,
        meta: {title: '发票详情'}
    },
    {
        path: "/expenseSelect",
        component: expenseSelect
    },
    {
        path: "/home",
        component: home,//路径重定向：保证一点开就是主页
    },
    {
        path: "/wuye_finance_refund_apply", //退款
        component: refund //对应的组件
    },
    {
        path: "/wuye_finance_derated_apply", //减免
        component: derated //对应的组件
    },
    {
        path: "/wuye_patrol_plan", //巡逻计划
        component: plan //对应的组件
    },
    {
        path: "/wuye_patrol_route", //巡逻路线
        component: route //对应的组件
    },
    {
        path: "/wuye_quality_plan", //品质计划
        component: qualityplan //对应的组件
    },
    {
        path: "/wuye_equipment_annual_inspection_record", //设备年检
        component: equipmentAnnualInspection //对应的组件
    },
    {
        path: "/wuye_equipment_maintenance", //设备维保
        component: equipmentMaintenance //对应的组件
    },
    {
        path: "/wuye_quality_task", //品质任务
        component: qualityTask //对应的组件
    },

    {
        path: "/wuye_decorate_info", //装修
        component: decorateInfo //对应的组件
    },
    {
        path: '/wuye_decorate_info_waterproof_acceptance', // 装修防水验收
        component: decorateWaterproof
    },
    {
        path: "/wuye_decorate_info_acceptance", //装修完工验收
        component: decorateAcceptance //对应的组件
    },
    {
        path: '/wuye_decorate_info_waterproof_acceptance_view',
        component: decorateWaterproofView
    },
    {
        path: "/wuye_quality_rectify", //品质整改
        component: qualityRectify //对应的组件
    },
    {
        path: "/wuye_small_community_consultation", //小区资讯
        component: CommunityConsultation //对应的组件
    },
    {
        path: "/wuye_small_notification", //通知公告
        component: notice //对应的组件
    },
    {
        path: "/wuye_archive_info", //档案信息目录
        component: archiveInfo //对应的组件
    },
    {
        path: "/wuye_archive_type", //档案类别目录
        component: archiveType //对应的组件
    },
    {
        path: "/wuye_extension_bid", //招投标管理
        component: extensionBid //对应的组件
    },
    {
        path: "/wuye_extension_survey", //项目调研
        component: extensionSurvey //对应的组件
    },
    {
        path: "/wuye_handover_doc", //资料交接
        component: handoverDoc //对应的组件
    },
    {
        path: "/wuye_handover_withdrawal", //项目交接
        component: handoverWithdrawal //对应的组件
    },
    // {
    // 	path: "/wuye_infacy_building_inspection", //收楼验房
    // 	component: buildingInspection //对应的组件
    // },
    // {
    // 	path: "/wuye_infacy_household_acceptance", //分户验收
    // 	component: houseHoldAcceptance //对应的组件
    // },
    {
        path: "/wuye_infacy_project_reception", //项目接收
        component: infacyProjectReception //对应的组件
    },
    // {
    // 	path: "/wuye_infacy_undertake_inspection", //承接查验
    // 	component: undertakeInspection //对应的组件
    // },
    {
        path: "/wuye_base_corp_info",  // 业务单位信息目录
        component: businessUnitInfo //对应的组件
    },
    {
        path: '/wuye_equipment_archive', // 设备信息档案
        component: equipmentInfoFile //对应的组件
    },
    {
        path: '/wuye_equipment_plan', // 设备巡检计划
        component: EquipmentInspectionPlan //对应的组件
    },
    {
        path: '/wuye_quality_inspection_standard', // 品质检查标准
        component: QualityInspectionStandard //对应的组件
    },
    {
        path: '/wuye_finance_receipt_master', // 收据管理（领用）
        component: ReceiptManagement //对应的组件
    },
    {
        path: '/wuye_daily_notice', // 物业通知管理
        component: WuYeNoticeManagement //对应的组件
    },
    {
        path: '/wuye_base_project', // 物业项目信息
        component: wuyeProjectInfo //对应的组件
    },
    {
        path: '/wuye_daily_check', // 双随机检查管理
        component: DoubleRandomCheckManagement //对应的组件
    },
    {
        path: '/wuye_daily_emergency', // 突发事件处理
        component: EmergencyHandling //对应的组件
    },
    {
        path: '/wuye_base_house_type', // 物业类型
        component: houseType //对应的组件
    },
    {
        path: '/wuye_base_customer_type', // 客户类型
        component: customerType //对应的组件
    },
    {
        path: '/wuye_base_fee_item', // 收费项目
        component: feeItem //对应的组件
    },
    {
        path: '/wuye_base_fee_norm', // 收费标准
        component: feeNorm //对应的组件
    },
    {
        path: '/wuye_base_car', // 车辆信息
        component: baseCar //对应的组件
    },
    {
        path: '/wuye_customer_project', // 客户基本信息目录
        component: customerProject //对应的组件
    },
    {
        path: '/wuye_base_customer_project', // 招商客户信息
        component: customerProject //对应的组件
    },
    {
        path: '/wuye_order_handover', // 秩序维护交接班管理
        component: orderHandover //对应的组件
    },
    {
        path: '/wuye_order_monitor', // 秩序维护监控室值班管理
        component: orderMonitor //对应的组件
    },
    {
        path: '/wuye_base_building', // 物业构成楼栋信息
        component: baseBuilding //对应的组件
    },
    {
        path: '/wuye_base_house', // 物业构成信息
        component: baseHouse
    },
    {
        path: '/wuye_finance_derated', // 批量减免、单价减免
        component: plDerated
    },
    {
        path: '/wuye_finance_derated_detail', // 批量减免、单价减免明细
        component: plDeratedDetail
    },
    {
        path: '/wuye_input_basis_info', // 录入依据档案信息目录
        component: inputBasisInfo
    },
    {
        path: '/wuye_base_meter_info',  // 计量表信息目录
        component: meterInfo
    },
    {
        path: '/wuye_base_meter_change', // 计量表换表管理
        component: meterChange
    },
    {
        path: '/wuye_finance_handover_doc', // 财务资料交接
        component: financeHandoverDoc
    },
    {
        path: '/wuye_param_meter_type', // 计量表类型
        component: meterType
    },
    {
        path: '/wuye_base_project_photo', // 项目图库类别
        component: projectPhotoType
    },
    {
        path: '/wuye_base_general_template_category', // 通用模版类别
        component: generalTemplateCategory
    },
    {
        path: '/wuye_base_general_template', // 通用模版管理
        component: generalTemplate
    },
    {
        path: '/wuye_base_project_map', // 项目图库信息
        component: projectPhoto
    },
    {
        path: '/wuye_points_gift', // 礼品设置
        component: giftSetting
    },
    {
        path: '/wuye_decorate_rectify', // 违章整改管理
        component: decorateRectify
    },
    {
        path: '/wuye_decorate_garbage_clear', // 装修垃圾清运
        component: decorateGarbageClear
    },
    {
        path: '/wuye_custserv_base', // 客服报事
        component: baseCustServReport
    },
    {
        path: '/wuye_custserv_complaint', // 投诉管理
        component: complaint
    },
    {
        path: '/wuye_custserv_maintain', // 维修管理
        component: maintain
    },
    {
        path: '/wuye_know_type', // 知识库类别
        component: knowType
    },
    {
        path: '/wuye_base_house_delivery', // 物业构成-交付信息
        component: deliveryInfo
    },
    {
        path: '/wuye_base_house_customer', // 物业构成-客户列表
        component: customerListInfo
    },
    {
        path: '/wuye_base_house_fee_norm', // 物业构成-收费标准
        component: feeItemInfo
    },
    {
        path: '/wuye_small_banner', // 小程序-轮播图
        component: banner
    },
    {
        path: '/noticeDetail', // 公告详情
        component: noticeDetail
    },
    {
        path: '/wuye_small_surround', // 小程序-周边配套/物业手册/装修资料
        component: smallSurround
    },
    {
        path: '/wuye_daily_order_firefighting', // 日常管理-秩序维护消控室值班管理
        component: fireFighting
    },
    {
        path: '/wuye_daily_virescence', // 日常管理-绿化种植养护
        component: virescene
    },
    {
        path: '/wuye_equipment_sign_label', // 设备标识标牌
        component: equipmentSignLabel
    },
    {
        path: '/wuye_equipment_sign_label_download_apply', // 设备标识标牌
        component: equipmentSignLabelApply
    },
    {
        path: '/shye_contract_derated', // 合同减免
        component: contractDerated
    },
    {
        path: '/shye_contract', // 合同
        component: contractContracts
    },
    {
        path: '/shye_contract_view', // 合同正文查看
        component: contractView
    },
    {
        path: '/shye_contract_info', // 合同列表
        component: contractInfo
    },
    {
        path: '/shye_contract_change', // 合同变更
        component: contractChange
    },
    {
        path: '/shye_leasing_resources_appy', // 单价标准
        component: unitPrice
    },
    {
        path: '/shye_property', // 产权信息
        component: property
    },
    {
        path: '/shye_march_into', // 进场
        component: marchInto
    },
    {
        path: '/shye_march_into_detail', // 进场
        component: marchIntoDetail
    },
    {
        path: '/shye_march_out', // 撤场
        component: marchOut
    },
    {
        path: '/shye_march_out_detail', // 撤场
        component: marchOutDetail
    },
    {
        path: '/shye_march_out_fee_detail', //	应收明细
        component: marchOutFeeDetail
    },
    {
        path: '/shye_march_out_retention', // 撤场
        component: retention
    },
    {
        path: '/shye_customer', // 招商客户
        component: customer
    },
    {
        path: '/shye_brand', // 品牌
        component: brand
    },
    {
        path: '/shye_market', // 市场调研
        component: market
    },
    {
        path: '/shye_lease', // 意向单
        component: lease
    },
    {
        path: '/shye_switch_room', // 高配间
        component: switchRoom
    },
    {
        path: '/know_info', // 知识库信息目录
        component: knowInfo
    },
    {
        path: '/shye_decorate_rectify', // 违章整改
        component: shyedecorateRectify
    },
    {
        path: '/shye_decorate_garbage_clear', // 建筑垃圾
        component: shyedecorateGarbageClear
    },
    {
        path: '/shye_build_garbage_clear', // 装修垃圾
        component: buildGarbageClear
    },
    {
        path: '/shye_custserv', // 客服报事
        component: custserv
    },
    {
        path: '/shye_complaint', // 投诉管理
        component: shyecomplaint
    },
    {
        path: '/shye_maintain', // 维修管理
        component: shyemaintain
    },
    {
        path: '/shye_lease_detail', // 市场调研
        component: leaseDetail
    },
    {
        path: '/shye_customer_detail', //	应收明细
        component: customerDetail
    },
    {
        path: '/shye_leasing_resources', // 租赁资源
        component: resources
    },
    {
        path: '/shye_finance_adjust', // 单价调减
        component: adjust
    },
    {
        path: '/shye_finance_staging', // 单价分期
        component: staging
    },
    {
        path: '/shye_green_plan', // 绿化养护计划管理
        component: greenPlan
    },
    {
        path: '/shye_green_reseed', // 绿化补种信息管理
        component: greenReseed
    },
    {
        path: '/wuye_infacy_main',
        component: inspectionRectify   // 前期物业相关页面
    },
    // 审批中心页面
    {
        path: '/flowable/index',  // 审批中心待办
        component: flowableIndex
    },
    //<--------------- 以下为物料管理系统页面 --------------->
    {
        path: "/materHome",
        component: materHome,//路径重定向：保证一点开就是主页
    },
    {
        path: '/materApplybill', // 要料
        component: applybill
    },
    {
        path: '/materApplybillPrice', // 要料单价预审
        component: applybill
    },
    {
        path: '/materApplybill_detail', // 要料
        component: applybillDerated
    },
    {
        path: '/materContract', // 合同
        component: contract
    },
    {
        path: '/materContract_detail', // 物料台账
        component: materContractDerated
    },
    {
        path: '/materWarehouse', // 入库
        component: putstore
    },
    {
        path: '/materWarehouse_detail', // 入库
        component: putstoreDerated
    },
    {
        path: '/materReceipt', // 收料
        component: receipt
    },
    {
        path: '/materReceipt_receInvos_detail', // 收料
        component: receiptReceInvosDerated
    },
    {
        path: '/materReceipt_receivingSubs_detail', // 收料
        component: receiptReceivingSubsDerated
    },
    {
        path: '/materExWarehouse', // 出库
        component: delivery
    },
    {
        path: '/materExWarehouse_detail', // 出库
        component: deliveryDerated
    },
    {
        path: '/materPicking', // 领料
        component: picking
    },
    {
        path: '/materPicking_detail', // 领料
        component: pickingDerated
    },
    {
        path: '/materContractAdjust', // 补充合同
        component: contractAdjust
    },
    {
        path: '/materContractAdjust_detail', // 补充合同
        component: contractAdjustDerated
    },
    {
        path: '/materContractMaterAdjust', // 合同物料调整单
        component: contractMaterAdjust
    },
    {
        path: '/materContractMaterAdjust_detail', // 合同物料调整单
        component: contractMaterAdjustDerated
    },
    {
        path: '/materBudget', // 预算
        component: budget
    },
    {
        path: '/materBudget_detail', // 预算
        component: budgetDerated
    },
    {
        path: '/materBudgetAdjust', // 预算调整
        component: budgetAdjust
    },
    {
        path: '/materBudgetAdjust_detail', // 预算调整
        component: budgetAdjustDerated
    },
    {
        path: '/materSupplierBudget', // 施工单位要料预算
        component: supplierBudget
    },
    {
        path: '/materSupplierBudget_detail', // 施工单位要料预算
        component: supplierBudgetDerated
    },
    {
        path: '/materSupplierBudgetAdjust', // 施工单位要料预算调整
        component: supplierBudgetAdjust
    },
    {
        path: '/materSupplierBudgetAdjust_detail', // 施工单位要料预算调整
        component: supplierBudgetAdjustDerated
    },
    // {
    // 	path: '/materInvoice', // 发票
    // 	component: invoice
    // },
    // {
    // 	path: '/materInvoice_detail', // 发票
    // 	component: invoiceDerated
    // },
    {
        path: '/wuye_base_house_customer_march', // 业主铺进撤场
        component: CustomerMarch
    },
    // {
    // 	path: '/hr_basic_demo', // 人力资源示例模块
    // 	component: hrDemo
    // },
    // {
    // 	path: '/hr_basic_demo_his', // 人力资源示例模块变更申请
    // 	component: hrDemo
    // },
    // {
    // 	path: '/hr_basic_demo_temp', // 人力资源示例模块变更
    // 	component: hrDemo
    // },
    // {
    // 	path: '/hr_hire_regist_school', // 人力资源大中专院校信息
    // 	component: hrHireRegistSchool
    // },
    // {
    // 	path: '/hr_hire_regist_web', // 人力资源人才网站信息
    // 	component: hrHireRegistWeb
    // },
    // {
    // 	path: '/hr_hire_regist_work', // 人力资源职介中心信息
    // 	component: hrHireRegistWork
    // },
    // {
    // 	path: '/hr_hire_regist_plan', // 人力资源招聘计划信息
    // 	component: hrHireRegistPlan
    // },
    // {
    // 	path: '/hr_hire_regist_plan_his', // 人力资源招聘计划信息
    // 	component: hrHireRegistPlan
    // },
    // {
    // 	path: '/hr_hire_regist_plan_temp', // 人力资源招聘计划信息
    // 	component: hrHireRegistPlan
    // },
    //<--------------- 以下为费控管理系统页面 --------------->
    {
        path: '/basic_supplier_info', // 承包商信息
        component: supplierInfo
    },
    {
        path: '/cost_budget_preparation', // 支出预算编制
        component: budgetPreparation
    },
    {
        path: '/cost_budget_preparation_detail', // 支出预算编制详情
        component: budgetPreparationDetail
    },
    {
        path: '/cost_budget_preparation_adjustment', // 支出预算编制调整
        component: budgetPreparationAdjust
    },
    {
        path: '/cost_budget_preparation_adjust_detail', // 支出预算编制调整明细
        component: budgetPreparationAdjustDetail
    },
    {
        path: '/cost_contract_info', // 支出合同信息
        component: costContract
    },
    {
        path: '/cost_contract_adjustment_payment_plan', // 支出合同信息
        component: contractAdjustPayment
    },
    {
        path: '/cost_contract_workload_estimate', // 单价合同工作量核定单、事项单工作量核定单
        component: contractWorkloadEstimate
    },
    {
        path: '/cost_contract_workload_estimate_detail', // 单价合同工作量核定单详情
        component: contractWorkloadEstimateDetail
    },
    {
        path: '/cost_event_workload_estimate_detail', // 单价事项单工作量核定单详情
        component: eventWorkloadEstimateDetail
    },
    {
        path: '/cost_event_info', // 事项单
        component: costEvent
    },
    {
        path: '/cost_request_funds', // 合同付款申请、事项单付款申请、报销单
        component: costRequestFunds
    },
    {
        path: '/cost_event_adjust', // 事项单调整
        component: eventAdjust
    },
    {
        path: '/t_invoice', // 发票管理
        component: invoiceFlow
    },
    {
        path: '/vat_invoice_detail',
        component: vatInvoiceDetail
    },
    {
        path: '/ag_invoice_detail',
        component: agInvoiceDetail
    },
    //事项单
    {
        path: '/cost_claim_detail_table', // 报销单表格
        component: costClaimDetailTable
    },
    {
        path: '/cost_claim_travel_detail_table', // 差旅费报销单表格
        component: costClaimTravelDetailTable
    },
    {
        path: '/cost_request_reserve_funds', // 备用金申请
        component: costPaymentRequestReserveFunds
    },
    {
        path: '/cost_contract_settlement', // 合同结算
        component: contractSettlement
    },
    {
        path: '/cost_contract_warranty', // 合同质保
        component: contractWarranty
    },
    {
        path: '/cost_contract_deduction', // 合同扣款详情
        component: contractDeduction
    },
    {
        path: '/report_sryc_tztj', // 调增调减
        component: tztj
    },
    {
        path: '/shye_fee_assessment', // 收费考核分摊
        component: decompose
    },
    {
        path: '/cost_contract_change', // 合同异动
        component: () => import('@/views/pages/cost/contract/contractChange.vue')
    },
    //合同管理
    {
        path: '/cost_contract_type', // 合同类别
        component: ContractType
    },
    {
        path: '/erp_contract_format', // 格式合同
        component: ContractFormat
    },
    {
        path: '/erp_contract_must', // 必须订立合同事项目录
        component: ContractMust
    },
    {
        path: '/erp_contract_sign_role', // 合同订立审批权限
        component: ContractSignRole
    },
    {
        path: '/erp_contract_safe_keep', // 合同保管期限目录
        component: ContractSafeKeep
    },
    {
        path: '/erp_contract_circulation_approval', // 格式合同流转审批
        component: ContractCirculationApproval
    },
    {
        path: '/erp_contract_hq_approval', // 格式合同会签审批
        component: ContractHqApproval
    },
    {
        path: '/erp_contract_new_inner', // 内/外部制定（新）
        component: ContractNewInner
    },
    {
        path: '/erp_contract_new_template', // 合同打印模板设置
        component: ContractNewTemplate
    },
    {
        path: '/erp_contract_use', // 合同利用
        component: ContractUse
    },
    {
        path: '/erp_contract_dispute', // 合同纠纷
        component: ContractDispute
    },

    // 会签审批单
    {
        path: '/hq_contract', // 合同新签
        component: newContract
    },
    {
        path: '/hq_contract_renew', // 合同续签
        component: contractRenew
    },
    {
        path: '/hq_contract_advertisement', // 广告新签
        component: newAdvertisement
    },
    {
        path: '/hq_contract_advertisement_renew', // 广告续签
        component: advertisementRenew
    },
    {
        path: '/hq_contract_change', // 合同变更
        component: contractChange2
    },
    {
        path: '/hq_fee_plan', // 收费方案
        component: feePlan
    },
    {
        path: '/hq_approval_wuye_fee_reduce', // 物业费/空置房物业费减免
        component: wuyeFeeReduce
    },
    {
        path: '/hq_approval_parking_fee_reduce', // 停车费减免
        component: parkingFeeReduce
    },
    {
        path: '/hq_approval_refund', // 退款
        component: refund2
    },
    {
        path: '/hq_approval_internal_settlement', // 内部结算会签
        component: internalSettlement
    },
    {
        path: '/hq_approval_price_compare', // 比价会签
        component: comparePrice
    },
    {
        path: '/hq_approval_material_procurement', // 物料采购
        component: materialPurchase
    },
    {
        path: '/hq_approval_commission', // 销售佣金
        component: commission
    },
    {
        path: '/hq_approval_advertise_make', // 广告位制作
        component: advertiseMake
    },
    {
        path: '/hq_approval_charge_index_adjust', // 收费指标调整
        component: chargeIndexAdjust
    },
    {
        path: '/hq_approval_maintenance', // 维修保养
        component: maintenance
    },
    {
        path: '/hq_approval_machinery_leasing', //机械租赁
        component: machineryLeasing
    },
    {
        path: '/machineryLeasingDetail',
        component: machineryLeasingDetail
    },
    {
        path: '/hq_approval_advertise_promotion', // 广告宣传
        component: advertisePromotion
    },
    {
        path: '/hq_approval_daily_maintenance', // 日常维修
        component: dailyMaintenance
    },
    {
        path: '/hq_approval_other', // 其他
        component: other2
    },
    {
        path: '/hq_lxzc_other', // 其他
        component: LxzcOther2
    },
    {
        path: '/hq_lxcg', // 零星采购
        component: lxcg
    },
    {
        path: '/lxcgDetail', // 零星采购
        component: lxcgDetail
    },
    {
        path: '/hq_approval_project_credits',
        component: projectCredits
    },
    {
        path: '/projectCreditsDetail',
        component: projectCreditsDetail
    },
    {
        path: '/hq_approval_clear',
        component: clear2
    },
    {
        path: '/hq_approval_repair_retrofit',
        component: repairRetrofit
    },
    {
        path: '/hq_approval_method_price',
        component: methodPrice
    },
    {
        path: '/hq_general',
        component: hqGeneral
    },
    {
        path: '/methodPriceDetail',
        component: methodPriceDetail
    },
    {
        path: '/lxgc_start_info',
        component: startInfo
    },
    {
        path: '/lxgc_minor_repair',
        component: minorRepair
    },
    {
        path: '/lxgc_completion_acceptance',
        component: completionAcceptance
    },
    {
        path: '/lxgc_completion_settlement',
        component: completionSettlement
    },
    {
        path: '/completionSettlementDetail',
        component: completionSettlementDetail
    },
    {
        path: '/lxgc_contract_party_jia_confirm',
        component: contractPartyJiaConfirm
    },
    {
        path: '/contractPartyJiaConfirmDetail',
        component: contractPartyJiaConfirmDetail
    },
    {
        path: '/hq_gcsg',
        component: gcsg
    },
    {
        path: '/hq_disposal_items',
        component: hqDisposalItems
    },
    {
        path: '/hq_sales_contract',
        component: hqSalesContract
    },
    {
        path: '/hq_lxsr_other',
        component: () => import('@/views/pages/hq/leasing/fee/hqLxsrOther.vue')
    },
    {
        path: '/hq_approval_commerce',
        component: () => import('@/views/pages/hq/spend/contract/commerce.vue')
    },
    // 国际贸易系统
    {
        path: '/its_base_subject_template',
        component: () => import('@/views/pages/its/base/ItsBaseSubjectTemplate.vue')
    },
    {
        path: '/ItsBaseSubjectTemplateDetail',
        component: () => import('@/views/pages/its/base/ItsBaseSubjectTemplateDetail.vue')
    },
    {
        path: '/its_base_mater_type',
        component: () => import('@/views/pages/its/base/ItsBaseMaterType.vue')
    },
    {
        path: '/its_base_mater',
        component: () => import('@/views/pages/its/base/ItsBaseMater.vue')
    },
    {
        path: '/its_base_subject_template',
        component: () => import('@/views/pages/its/base/ItsBaseSubjectTemplate.vue')
    },
    {
        path: '/its_base_expense_items',
        component: () => import('@/views/pages/its/base/ItsBaseExpenseItems.vue')
    },
    {
        path: '/its_base_mater',
        component: () => import('@/views/pages/its/base/ItsBaseMater.vue')
    },
    {
        path: '/its_base_mater_rel',
        component: () => import('@/views/pages/its/base/ItsBaseMaterRel.vue')
    },
    {
        path: '/its_base_customer',
        component: () => import('@/views/pages/its/base/ItsBaseCustomer.vue')
    },
    {
        path: '/its_base_customer_inspect',
        component: () => import('@/views/pages/its/base/ItsBaseCustomerInspect.vue')
    },
    {
        path: '/its_base_port',
        component: () => import('@/views/pages/its/base/ItsBasePort.vue')
    },
    {
        path: '/its_base_consign_address',
        component: () => import('@/views/pages/its/base/ItsBaseConsignAddress.vue')
    },
    {
        path: '/its_base_pack_address',
        component: () => import('@/views/pages/its/base/ItsBasePackAddress.vue')
    },
    {
        path: '/its_base_pack_address_inspect',
        component: () => import('@/views/pages/its/base/ItsBasePackAddressInspect.vue')
    },
    {
        path: '/its_base_carrier',
        component: () => import('@/views/pages/its/base/ItsBaseCarrier.vue')
    },
    {
        path: '/its_base_brand',
        component: () => import('@/views/pages/its/base/ItsBaseBrand.vue')
    },
    {
        path: '/its_base_team',
        component: () => import('@/views/pages/its/reg/team/ItsBaseTeam.vue')
    },
    {
        path: '/ItsBaseTeamDetail',
        component: () => import('@/views/pages/its/reg/team/ItsBaseTeamDetail.vue')
    },
    {
        path: '/its_base_team_history',
        component: () => import('@/views/pages/its/reg/team/ItsBaseTeamHistory.vue')
    },
    {
        path: '/its_base_farm',
        component: () => import('@/views/pages/its/reg/farm/ItsBaseFarm.vue')
    },
    {
        path: '/its_base_farm_inspect',
        component: () => import('@/views/pages/its/reg/farm/ItsBaseFarmInspect.vue')
    },
    {
        path: '/its_order_depart_raw',
        component: () => import('@/views/pages/its/reg/order/ItsOrderDepartRaw.vue')
    },
    {
        path: '/ItsOrderDepartRawDetail',
        component: () => import('@/views/pages/its/reg/order/ItsOrderDepartRawDetail.vue')
    },
    {
        path: '/its_labor_daily',
        component: () => import('@/views/pages/its/reg/labor/ItsLaborDaily.vue')
    },
    {
        path: '/ItsLaborDailyDetail',
        component: () => import('@/views/pages/its/reg/labor/ItsLaborDailyDetail.vue')
    },
    {
        path: '/its_regist_agency_settle',
        component: () => import('@/views/pages/its/reg/regist/agency/ItsRegistAgency.vue')
    },
    {
        path: '/its_order_customs_apply',
        component: () => import('@/views/pages/its/reg/order/ItsOrderCustomsApply.vue')
    },
    {
        path: '/ItsOrderCustomsApplyDetail',
        component: () => import('@/views/pages/its/reg/order/ItsOrderCustomsApplyDetail.vue')
    },
    {
        path: '/its_base_cold_storage',
        component: () => import('@/views/pages/its/reg/coldStorage/ItsBaseColdStorage.vue')
    },
    {
        path: '/its_base_cold_storage_inspect',
        component: () => import('@/views/pages/its/reg/coldStorage/ItsBaseColdStorageInspect.vue')
    },
    {
        path: '/its_order_inbound',
        component: () => import('@/views/pages/its/reg/kcun/ItsOrderInBound.vue')
    },
    {
        path: '/ItsOrderInBoundDetail',
        component: () => import('@/views/pages/its/reg/kcun/ItsOrderInBoundDetail.vue')
    },
    {
        path: '/its_order_inbound_var',
        component: () => import('@/views/pages/its/reg/kcun/ItsOrderInBoundVar.vue')
    },
    {
        path: '/ItsOrderInBoundVarDetail',
        component: () => import('@/views/pages/its/reg/kcun/ItsOrderInBoundVarDetail.vue')
    },
    {
        path: '/its_order_outbound',
        component: () => import('@/views/pages/its/reg/kcun/ItsOrderOutBound.vue')
    },
    {
        path: '/ItsOrderOutBoundDetail',
        component: () => import('@/views/pages/its/reg/kcun/ItsOrderOutBoundDetail.vue')
    },
    {
        path: '/its_order_depart',
        component: () => import('@/views/pages/its/reg/order/ItsOrderDepart.vue')
    },
    {
        path: '/ItsOrderDepartDetail',
        component: () => import('@/views/pages/its/reg/order/ItsOrderDepartDetail.vue')
    },
    {
        path: '/its_order_dispose',
        component: () => import('@/views/pages/its/reg/kcun/ItsOrderDispose.vue')
    },
    {
        path: '/its_order_consume',
        component: () => import('@/views/pages/its/reg/kcun/ItsOrderConsume.vue')
    },
    {
        path: '/its_order_haulage_raw',
        component: () => import('@/views/pages/its/reg/logistics/ItsOrderHaulageRaw.vue')
    },
    {
        path: '/its_order_haulage',
        component: () => import('@/views/pages/its/reg/logistics/ItsOrderHaulage.vue')
    },
    {
        path: '/its_order_haulage_huan',
        component: () => import('@/views/pages/its/reg/logistics/ItsOrderHaulageHuan.vue')
    },
    {
        path: '/its_order_haulage_abroad',
        component: () => import('@/views/pages/its/reg/logistics/ItsOrderHaulageAbroad.vue')
    },
    {
        path: '/its_order_customs_clear',
        component: () => import('@/views/pages/its/reg/order/ItsOrderCustomsClear.vue')
    },
    {
        path: '/its_sales_domestic',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesDomestic.vue')
    },
    {
        path: '/ItsSalesDomesticDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesDomesticDetail.vue')
    },
    {
        path: '/its_sales_foreign_sales_order',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesForeignSalesOrder.vue')
    },
    {
        path: '/ItsSalesDepartDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesDepartDetail.vue')
    },
    {
        path: '/ItsSalesOrderDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesOrderDetail.vue')
    },
    {
        path: '/ItsSalesFeeDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesFeeDetail.vue')
    },
    {
        path: '/its_sales_foreign_sales_settlement',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesForeignSalesSettlement.vue')
    },
    {
        path: '/its_regist_overheads',
        component: () => import('@/views/pages/its/reg/regist/overheads/ItsRegistOverheads.vue')
    },
    {
        path: '/ItsRegistOverheadsDetail',
        component: () => import('@/views/pages/its/reg/regist/overheads/ItsRegistOverheadsDetail.vue')
    },
    {
        path: '/its_regist_attn',
        component: () => import('@/views/pages/its/reg/labor/ItsRegistAttn.vue')
    },
    {
        path: '/its_forecast',
        component: () => import('@/views/pages/its/reg/forecast/ItsForecast.vue')
    },
    {
        path: '/ItsForecastDetail',
        component: () => import('@/views/pages/its/reg/forecast/ItsForecastDetail.vue')
    },
    {
        path: '/its_forecast_adjust',
        component: () => import('@/views/pages/its/reg/forecast/ItsForecastAdjust.vue')
    },
    {
        path: '/ItsForecastAdjustDetail',
        component: () => import('@/views/pages/its/reg/forecast/ItsForecastAdjustDetail.vue')
    },
    {
        path: '/its_logistic_market_arrival',
        component: () => import('@/views/pages/its/reg/logistics/ItsLogisticMarketArrival.vue')
    },
    {
        path: '/its_sales_reg_once',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesVehicle.vue')
    },
    {
        path: '/ItsSalesVehicleSalesDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesVehicleSalesDetail.vue')
    },
    {
        path: '/its_cold_storage_fee',
        component: () => import('@/views/pages/its/reg/fee/ItsColdStorageFee.vue')
    },
    {
        path: '/ItsColdStorageFeeDetail',
        component: () => import('@/views/pages/its/reg/fee/ItsColdStorageFeeDetail.vue')
    },
    {
        path: '/ItsContractCustomsAffair',
        component: () => import('@/views/pages/its/reg/contract/ItsContractCustomsAffair.vue')
    },
    {
        path: '/ItsContractLabor',
        component: () => import('@/views/pages/its/reg/contract/ItsContractLabor.vue')
    },
    {
        path: '/materReturn',
        component: () => import('@/views/pages/mater/materReturn.vue')
    },
    {
        path: '/materReturn_detail',
        component: () => import('@/views/pages/mater/materReturn_Detail.vue')
    },
    {
        path: '/materTransfer',
        component: () => import('@/views/pages/mater/materTransfer.vue')
    },
    {
        path: '/materTransfer_detail',
        component: () => import('@/views/pages/mater/materTransfer_Detail.vue')
    },
    {
        path: '/materDispose',
        component: () => import('@/views/pages/mater/materDispose.vue')
    },
    {
        path: '/materDispose_detail',
        component: () => import('@/views/pages/mater/materDispose_Detail.vue')
    },
    {
        path: '/materMove',
        component: () => import('@/views/pages/mater/materMove.vue')
    },
    {
        path: '/materMove_detail',
        component: () => import('@/views/pages/mater/materMove_Detail.vue')
    },
    {
        path: '/materSale',
        component: () => import('@/views/pages/mater/materSale.vue')
    },
    {
        path: '/materSale_detail',
        component: () => import('@/views/pages/mater/materSale_Detail.vue')
    },
    {
        path: '/materTransport',
        component: () => import('@/views/pages/mater/materTransport.vue')
    },
    {
        path: '/materLend',
        component: () => import('@/views/pages/mater/materLend.vue')
    },
    {
        path: '/materLend_detail',
        component: () => import('@/views/pages/mater/materLend_Detail.vue')
    },
    {
        path: '/materConvert',
        component: () => import('@/views/pages/mater/materConvert.vue')
    },
    {
        path: '/materConvert_Detail',
        component: () => import('@/views/pages/mater/materConvert_Detail.vue')
    },
    {
        path: '/materConvertOutput_Detail',
        component: () => import('@/views/pages/mater/materConvertOutput_Detail.vue')
    },
    {
        path: '/its_contract',
        component: () => import('@/views/pages/cost/contract/contractIts.vue')
    },
    {
        path: '/ItsContractAgency',
        component: () => import('@/views/pages/its/reg/contract/ItsContractAgency.vue')
    },
    {
        path: '/ItsContractPurchase',
        component: () => import('@/views/pages/its/reg/contract/ItsContractPurchase.vue')
    },
    {
        path: '/ItsContractCarrier',
        component: () => import('@/views/pages/its/reg/contract/ItsContractCarrier.vue')
    },
    {
        path: '/ItsContractRentCold',
        component: () => import('@/views/pages/its/reg/contract/ItsContractRentCold.vue')
    },
    {
        path: '/ItsContractRentPack',
        component: () => import('@/views/pages/its/reg/contract/ItsContractRentPack.vue')
    },
    {
        path: '/ItsContractCustomsInspect',
        component: () => import('@/views/pages/its/reg/contract/ItsContractCustomsInspect.vue')
    },
    {
        path: '/ItsContractCustomsApply',
        component: () => import('@/views/pages/its/reg/contract/ItsContractCustomsApply.vue')
    },
    {
        path: '/ItsContractSalesFormFlow',
        component: () => import('@/views/pages/its/reg/contract/ItsContractSales.vue')
    },
    {
        path: '/its_forecast_all',
        component: () => import('@/views/pages/its/reg/forecast/ItsForecastAll.vue')
    },
    {
        path: '/its_sales_settle',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesSettle.vue')
    },
    {
        path: '/its_base_job_type',
        component: () => import('@/views/pages/its/base/ItsBaseJobType.vue')
    },
    {
        path: '/its_dispatch',
        component: () => import('@/views/pages/its/reg/dispatch/ItsDispatch.vue')
    },
    {
        path: '/itsHome',
        component: () => import('@/views/itsHome.vue')
    },
    {
        path: '/its_base_trading_country',
        component: () => import('@/views/pages/its/base/ItsBaseTradingCountry.vue')
    },
    {
        path: '/its_base_customs',
        component: () => import('@/views/pages/its/base/ItsBaseCustoms.vue')
    },
    {
        path: '/its_customs_apply',
        component: () => import('@/views/pages/its/reg/customs/ItsCustomsApply.vue')
    },
    {
        path: '/its_customs_apply_amount',
        component: () => import('@/views/pages/its/reg/customs/ItsCustomsApplyFee.vue')
    },
    {
        path: '/its_customs_declaration',
        component: () => import('@/views/pages/its/reg/customs/ItsCustomsDeclearation.vue')
    },
    {
        path: '/its_customs_declaration_result',
        component: () => import('@/views/pages/its/reg/customs/ItsCustomsDeclearationResult.vue')
    },
    {
        path: '/its_customs_declaration_amount',
        component: () => import('@/views/pages/its/reg/customs/ItsCustomsDeclearationFee.vue')
    },
    {
        path: '/its_logistic_dispatch',
        component: () => import('@/views/pages/its/reg/logistics/ItsOrderLogisticCar.vue')
    },
    {
        path: '/its_stock_raw_inbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawInBound.vue')
    },
    {
        path: '/ItsStockRawInBoundDepartDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawInBoundDepartDetail.vue')
    },
    {
        path: '/ItsStockRawInBoundWarehousingDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawInBoundWarehousingDetail.vue')
    },
    {
        path: '/its_stock_raw_wash_inbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawWashInBound.vue')
    },
    {
        path: '/ItsStockRawWashInBoundDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawWashInBoundDetail.vue')
    },
    {
        path: '/its_stock_precool_inbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockPrecoolInBound.vue')
    },
    {
        path: '/ItsStockPrecoolInBoundDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockPrecoolInBoundDetail.vue')
    },
    {
        path: '/ItsStockPrecoolMaterOutboundDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockPrecoolMaterOutboundDetail.vue')
    },
    {
        path: '/ItsStockPrecoolMaterInboundDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockPrecoolMaterInBoundDetail.vue')
    },
    {
        path: '/ItsStockPrecoolMaterUseDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockPrecoolMaterUseDetail.vue')
    },
    {
        path: '/its_stock_scatter_inbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockScatterInBound.vue')
    },
    {
        path: '/ItsStockScatterInBoundDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockScatterInBoundDetail.vue')
    },
    {
        path: '/its_stock_fruit_outbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockFruitOutBound.vue')
    },
    {
        path: '/ItsStockFruitOutBoundDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockFruitOutBoundDetail.vue')
    },
    {
        path: '/ItsStockFruitOutBoundSecondaryDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockFruitOutBoundSecondaryDetail.vue')
    },
    {
        path: '/its_logistic_fee',
        component: () => import('@/views/pages/its/reg/logistics/ItsOrderDepartFee.vue')
    },
    {
        path: '/its_stock_raw_outbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawOutBound.vue')
    },
    {
        path: '/ItsStockRawOutBoundDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawOutBoundDetail.vue')
    },
    {
        path: '/its_logistic_request',
        component: () => import('@/views/pages/its/reg/logistics/ItsLogisticRequest.vue')
    },
    {
        path: '/its_apply_bill',
        component: () => import('@/views/pages/its/reg/mater/ItsApplyBill.vue')
    },
    {
        path: '/its_stock_raw_add_inventory',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawAddInventory.vue')
    },
    {
        path: '/ItsStockRawAddInventoryDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawAddInventoryDetail.vue')
    },
    {
        path: '/its_stock_raw_return',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawReturn.vue')
    },
    {
        path: '/ItsStockRawReturnDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockRawReturnDetail.vue')
    },
    {
        path: '/its_contract_fee_settlement',
        component: () => import('@/views/pages/its/reg/contractSettlement/ItsContractFeeSettlement.vue')
    },
    {
        path: '/its_stock_scatter_outbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockScatterOutBound.vue')
    },
    {
        path: '/ItsStockScatterOutBoundDetail',
        component: () => import('@/views/pages/its/reg/stock/ItsStockScatterOutBoundDetail.vue')
    },
    {
        path: '/its_stock_pack_material_loss',
        component: () => import('@/views/pages/its/reg/stock/ItsStockPackMaterialLoss.vue')
    },
    {
        path: '/its_stock_bulk_pack_inbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockBulkPackInBound.vue')
    },
    {
        path: '/its_stock_fruit_repack_inbound',
        component: () => import('@/views/pages/its/reg/stock/ItsStockFruitRepackInBound.vue')
    },
    {
        path: '/its_sales_depart',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesDepart.vue')
    },
    {
        path: '/ItsSalesDepartDetailNew',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesDepartDetailNew.vue')
    },
    {
        path: '/its_logistic_waybill',
        component: () => import('@/views/pages/its/reg/logistics/ItsLogisticWaybill.vue')
    },
    {
        path: '/ItsWaybillDetail',
        component: () => import('@/views/pages/its/reg/logistics/ItsWaybillDetail.vue')
    },
    {
        path: '/ItsWaybillDetailSecond',
        component: () => import('@/views/pages/its/reg/logistics/ItsWaybillDetailSecond.vue')
    },
    {
        path: '/its_sales_reg',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesReg.vue')
    },
    {
        path: '/ItsSalesRegOutboundDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesRegOutboundDetail.vue')
    },
    {
        path: '/ItsSalesRegPriceDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesRegPriceDetail.vue')
    },
    {
        path: '/its_logistic_transfer',
        component: () => import('@/views/pages/its/reg/logistics/ItsLogisticTransfer.vue')
    },
    {
        path: '/its_logistic_transfer_second',
        component: () => import('@/views/pages/its/reg/logistics/ItsLogisticTransferSecond.vue')
    },
    {
        path: '/its_sales_outer',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesOuter.vue')
    },
    {
        path: '/ItsSalesOuterDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesOuterDetail.vue')
    },
    {
        path: '/ItsSalesOuterSalesDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesOuterSalesDetail.vue')
    },
    {
        path: '/ItsSalesOuterAbroadDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesOuterAbroadDetail.vue')
    },
    {
        path: '/ItsSalesOuterAbroadFeeDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesOuterAbroadFeeDetail.vue')
    },
    {
        path: '/its_sales_inner',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesInner.vue')
    },
    {
        path: '/ItsSalesInnerDepartDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesInnerDepartDetail.vue')
    },
    {
        path: '/ItsSalesInnerSalesDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesInnerSalesDetail.vue')
    },
    {
        path: '/ItsSalesInnerSpendDepartDetail',
        component: () => import('@/views/pages/its/reg/sales/ItsSalesInnerSpendDepartDetail.vue')
    },
    {
        path: '/its_base_contractor_inspect',
        component: () => import('@/views/pages/its/base/ItsBaseContractorInspect.vue')
    },
    {
        path: '/its_base_secondary_cold_storage',
        component: () => import('@/views/pages/its/reg/coldStorage/ItsBaseSecondaryColdStorage.vue')
    },
    // 法务管理
    {
        path: '/lams_reg_legal_doc',
        component: () => import('@/views/pages/lams/lamsRegLegalDoc.vue')
    },
    {
        path: '/lams_reg_legal_adviser_approval',
        component: () => import('@/views/pages/lams/lamsRegLegalAdviserApproval.vue')
    },
    {
        path: '/lams_reg_legal_adviser',
        component: () => import('@/views/pages/lams/lamsRegLegalAdviser.vue')
    },
    {
        path: '/lams_reg_legal_consult_approval',
        component: () => import('@/views/pages/lams/lamsRegLegalConsultApproval.vue')
    },
    {
        path: '/lams_reg_legal_consult_info',
        component: () => import('@/views/pages/lams/lamsRegLegalConsultInfo.vue')
    },
    {
        path: '/lams_reg_legal_consult_summary',
        component: () => import('@/views/pages/lams/lamsRegLegalConsultSummary.vue')
    },
    {
        path: '/lamsRegLegalConsultSummaryDetail',
        component: () => import('@/views/pages/lams/lamsRegLegalConsultSummaryDetail.vue')
    },
    {
        path: '/lams_reg_legal_opinion',
        component: () => import('@/views/pages/lams/lamsRegLegalOpinion.vue')
    },
    {
        path: '/lams_reg_legal_annual_report',
        component: () => import('@/views/pages/lams/lamsRegLegalAnnualReport.vue')
    },
    {
        path: '/lams_reg_legal_doc_review',
        component: () => import('@/views/pages/lams/lamsRegLegalDocReview.vue')
    },
    {
        path: '/lams_reg_legal_litigation_process',
        component: () => import('@/views/pages/lams/lamsRegLegalLitigationProcess.vue')
    },
    {
        path: '/lams_reg_legal_litigation_info',
        component: () => import('@/views/pages/lams/lamsRegLegalLitigationInfo.vue')
    },
    {
        path: '/lams_reg_legal_training',
        component: () => import('@/views/pages/lams/lamsRegLegalTraining.vue')
    },
    {
        path: '/lamsPresentList',
        component: () => import('@/views/pages/lams/lamsPresentList.vue')
    },
    {
        path: '/lamsAbsentList',
        component: () => import('@/views/pages/lams/lamsAbsentList.vue')
    },
    {
        path: '/lams_reg_legal_litigation_info_execution_track',
        component: () => import('@/views/pages/lams/lamsRegLegalLigationInfoTrack.vue')
    },
    {
        path: '/lams_base_legal_category',
        component: () => import('@/views/pages/lams/LamsBaseLegalCategory.vue')
    },
    {
        path: '/lams_base_legal_counselor_hire_type',
        component: () => import('@/views/pages/lams/LamsBaseLegalCounselorHireType.vue')
    },
    {
        path: '/lams_base_legal_doc_type',
        component: () => import('@/views/pages/lams/LamsBaseLegalDocType.vue')
    },
    {
        path: '/lams_base_legal_procedure_level',
        component: () => import('@/views/pages/lams/LamsBaseLegalProcedureLevel.vue')
    },
    {
        path: '/lams_base_legal_archive_reference',
        component: () => import('@/views/pages/lams/LamsBaseLegalArchiveReference.vue')
    },
    // 行政管理
    {
        path: '/aams_reg_seal_usage_approval',
        component: () => import('@/views/pages/aams/seal/AamsRegSealUsageApproval.vue')
    },
    {
        path: '/AamsRegSealUsageApprovalDetail',
        component: () => import('@/views/pages/aams/seal/AamsRegSealUsageApprovalDetail.vue')
    },
    {
        path: '/aams_reg_seal_engrave_approval',
        component: () => import('@/views/pages/aams/seal/AamsRegSealEngraveApproval.vue')
    },
    {
        path: '/aams_reg_seal_engrave_record',
        component: () => import('@/views/pages/aams/seal/AamsRegSealEngraveRecord.vue')
    },
    {
        path: '/AamsFeeDetail',
        component: () => import('@/views/pages/aams/seal/feeDetail.vue')
    },
    {
        path: '/aams_reg_seal_auth_approval',
        component: () => import('@/views/pages/aams/seal/AamsRegSealAuthApproval.vue')
    },
    {
        path: '/aams_reg_seal_auth_record',
        component: () => import('@/views/pages/aams/seal/AamsRegSealAuthRecord.vue')
    },
    {
        path: '/aams_reg_seal_disposal_approval',
        component: () => import('@/views/pages/aams/seal/AamsRegSealDisposalApproval.vue')
    },
    {
        path: '/aams_reg_seal_disposal_record',
        component: () => import('@/views/pages/aams/seal/AamsRegSealDisposalRecord.vue')
    },
    {
        path: '/aams_reg_seal_usage_record',
        component: () => import('@/views/pages/aams/seal/AamsRegSealUsageRecord.vue')
    },
    {
        path: '/AamsRegSealUsageRecordDetail',
        component: () => import('@/views/pages/aams/seal/AamsRegSealUsageRecordDetail.vue')
    },
    {
        path: '/aams_reg_seal_incident_report',
        component: () => import('@/views/pages/aams/seal/AamsRegSealIncidentReport.vue')
    },
    {
        path: '/aams_reg_seal_annual_record',
        component: () => import('@/views/pages/aams/seal/AamsRegSealAnnualRecord.vue')
    },
    {
        path: '/aams_base_seal_category',
        component: () => import('@/views/pages/aams/seal/AamsBaseSealCategory.vue')
    },
    {
        path: '/aams_base_seal_reason_category',
        component: () => import('@/views/pages/aams/seal/AamsBaseSealReasonCategory.vue')
    },
    {
        path: '/aams_base_seal_approval_permission',
        component: () => import('@/views/pages/aams/seal/AamsBaseSealApprovalPermission.vue')
    },
    {
        path: '/aams_base_seal_catalog_register',
        component: () => import('@/views/pages/aams/seal/AamsBaseSealCatalogRegister.vue')
    },
    {
        path: '/aams_reg_seal_auth_record_recall',
        component: () => import('@/views/pages/aams/seal/AamsRegSealAuthRecordRecall.vue')
    },
    // 企业管理
    {
        path: '/cms_base_type',
        component: () => import('@/views/pages/erp/cms/base/CmsBaseType.vue')
    },
    {
        path: '/cms_regist_annual',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistAnnual.vue')
    },
    {
        path: '/cms_regist_zsku',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistZsku.vue')
    },
    {
        path: '/CmsRegistZskuDetail',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistZskuDetail.vue')
    },
    {
        path: '/cms_work_plan',
        component: () => import('@/views/pages/erp/cms/work/CmsWorkPlan.vue')
    },
    {
        path: '/cms_work_daily',
        component: () => import('@/views/pages/erp/cms/work/CmsWorkDaily.vue')
    },
    {
        path: '/cms_base_sop_type',
        component: () => import('@/views/pages/erp/cms/base/CmsBaseSopType.vue')
    },
    {
        path: '/cms_sop_content_pre',
        component: () => import('@/views/pages/erp/cms/sop/CmsSopContentPre.vue')
    },
    {
        path: '/cms_sop_content',
        component: () => import('@/views/pages/erp/cms/sop/CmsSopContent.vue')
    },
    {
        path: '/cms_integrity_info',
        component: () => import('@/views/pages/erp/cms/integrity/CmsIntegrityInfo.vue')
    },
    {
        path: '/cms_integrity_educate',
        component: () => import('@/views/pages/erp/cms/integrity/CmsIntegrityEducate.vue')
    },
    {
        path: '/cms_safe_educate',
        component: () => import('@/views/pages/erp/cms/safe/CmsSafeEducate.vue')
    },
    {
        path: '/cms_safe_sign',
        component: () => import('@/views/pages/erp/cms/safe/CmsSafeSign.vue')
    },
    {
        path: '/cms_safe_check',
        component: () => import('@/views/pages/erp/cms/safe/CmsSafeCheck.vue')
    },
    {
        path: '/cms_safe_accident',
        component: () => import('@/views/pages/erp/cms/safe/CmsSafeAccident.vue')
    },
    {
        path: '/cms_insure_content_pre',
        component: () => import('@/views/pages/erp/cms/insure/CmsInsureContentPre.vue')
    },
    {
        path: '/cms_insure_content',
        component: () => import('@/views/pages/erp/cms/insure/CmsInsureContent.vue')
    },
    {
        path: '/cms_insure_claim',
        component: () => import('@/views/pages/erp/cms/insure/CmsInsureClaim.vue')
    },
    {
        path: '/cms_regist_affair',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistAffair.vue')
    },
    {
        path: '/cms_regist_crisis',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistCrisis.vue')
    },
    {
        path: '/cms_attend_pre',
        component: () => import('@/views/pages/erp/cms/attend/CmsAttendPre.vue')
    },
    {
        path: '/cms_attend_content',
        component: () => import('@/views/pages/erp/cms/attend/CmsAttendContent.vue')
    },
    {
        path: '/cms_work_finish',
        component: () => import('@/views/pages/erp/cms/work/CmsWorkFinish.vue')
    },
    {
        path: '/cms_work_plan_adjust',
        component: () => import('@/views/pages/erp/cms/work/CmsWorkPlanAdjust.vue')
    },
    {
        path: '/cms_work_perf',
        component: () => import('@/views/pages/erp/cms/work/CmsWorkPlanPerf.vue')
    },
    {
        path: '/CmsWorkPlanPerfDetail',
        component: () => import('@/views/pages/erp/cms/work/CmsWorkPlanPerfDetail.vue')
    },
    {
        path: '/cms_work_check',
        component: () => import('@/views/pages/erp/cms/work/CmsWorkCheck.vue')
    },
    {
        path: '/CmsWorkCheckDetail',
        component: () => import('@/views/pages/erp/cms/work/CmsWorkCheckDetail.vue')
    },
    {
        path: '/cms_meeting_pre',
        component: () => import('@/views/pages/erp/cms/meet/CmsMeetingPre.vue')
    },
    {
        path: '/cms_meeting',
        component: () => import('@/views/pages/erp/cms/meet/CmsMeeting.vue')
    },
    {
        path: '/cms_meeting_dept',
        component: () => import('@/views/pages/erp/cms/meet/CmsMeetingDept.vue')
    },
    {
        path: '/cms_regist_talk',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistTalk.vue')
    },
    {
        path: '/cms_regist_talk_contact',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistTalkContact.vue')
    },
    {
        path: '/cms_regist_suggest',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistSuggest.vue')
    },
    {
        path: '/cms_regist_obstacle_info',
        component: () => import('@/views/pages/erp/cms/obstacle/CmsRegistObstacleInfo.vue')
    },
    {
        path: '/cms_regist_obstacle_pre',
        component: () => import('@/views/pages/erp/cms/obstacle/CmsRegistObstaclePre.vue')
    },
    {
        path: '/cms_regist_obstacle',
        component: () => import('@/views/pages/erp/cms/obstacle/CmsRegistObstacle.vue')
    },
    {
        path: '/cms_regist_team',
        component: () => import('@/views/pages/erp/cms/regist/CmsRegistTeam.vue')
    },
    // 企业管理-用户权限分配管理
    {
        path: '/cms_icm_role_allo',
        component: () => import('@/views/pages/erp/cms/icm/CmsIcmRoleAllo.vue')
    },
    {
        path: '/cms_icm_role_allo_pre',
        component: () => import('@/views/pages/erp/cms/icm/CmsIcmRoleAlloPre.vue')
    },
    {
        path: '/cms_icm_role_name',
        component: () => import('@/views/pages/erp/cms/icm/CmsIcmRoleName.vue')
    },
    {
        path: '/cms_icm_standard',
        component: () => import('@/views/pages/erp/cms/icm/CmsIcmStandard.vue')
    },
    // 内控管理（路由路径须与流程 businessTable 一致，移动待办/已办按 table 名跳转）
    {
        path: '/erp_icm_backup_media',
        component: () => import('@/views/pages/erp/icm/backupMedia/ErpIcmBackupMedia.vue')
    },
    {
        path: '/erp_icm_backup_type',
        component: () => import('@/views/pages/erp/icm/backupType/ErpIcmBackupType.vue')
    },
    {
        path: '/erp_icm_db_backup',
        component: () => import('@/views/pages/erp/icm/dbBackup/ErpIcmDbBackup.vue')
    },
    {
        path: '/erp_icm_db_backup_check',
        component: () => import('@/views/pages/erp/icm/dbBackupCheck/ErpIcmDbBackupCheck.vue')
    },
    {
        path: '/erp_icm_room_access',
        component: () => import('@/views/pages/erp/icm/roomAccess/ErpIcmRoomAccess.vue')
    },
    {
        path: '/erp_icm_room_access_info',
        component: () => import('@/views/pages/erp/icm/roomAccessInfo/ErpIcmRoomAccessInfo.vue')
    },
    {
        path: '/erp_icm_room_equip_adjust',
        component: () => import('@/views/pages/erp/icm/roomEquipAdjust/ErpIcmRoomEquipAdjust.vue')
    },
    {
        path: '/erp_icm_room_equip_adjust_info',
        component: () => import('@/views/pages/erp/icm/roomEquipAdjustInfo/ErpIcmRoomEquipAdjustInfo.vue')
    },
    {
        path: '/erp_icm_db_data_use',
        component: () => import('@/views/pages/erp/icm/dbDataUse/ErpIcmDbDataUse.vue')
    },
    {
        path: '/erp_icm_db_data_use_info',
        component: () => import('@/views/pages/erp/icm/dbDataUseInfo/ErpIcmDbDataUseInfo.vue')
    },
    // 资金管理（路由路径须与流程 businessTable 一致，移动待办/已办按 table 名跳转）
    {
        path: '/funds_account_open',
        component: () => import('@/views/pages/funds/accountOpen/FundsAccountOpen.vue')
    },
    {
        path: '/funds_account_open_info',
        component: () => import('@/views/pages/funds/accountInfo/FundsAccountOpenInfo.vue')
    },
    {
        path: '/funds_bank',
        component: () => import('@/views/pages/funds/bank/FundsBank.vue')
    },
    {
        path: '/funds_account_cancel',
        component: () => import('@/views/pages/funds/accountCancel/FundsAccountCancel.vue')
    },
    // 人力资源
    {
        path: '/hr_hire_adjust_org',
        component: () => import('@/views/pages/hr/basic/eeadjust/HrHireAdjustOrg.vue')
    },
    {
        path: '/hr_salary_rank_grant_adjust',
        component: () => import('@/views/pages/hr/salary/rank/HrSalaryRankGrantAdjust.vue')
    },
    {
        path: '/hr_basic_corp',
        component: () => import('@/views/pages/hr/basic/corp/HrBasicCorp.vue')
    },
    {
        path: '/hr_basic_corp_his',
        component: () => import('@/views/pages/hr/basic/corp/HrBasicCorpHis.vue')
    },
    {
        path: '/hr_basic_corp_temp',
        component: () => import('@/views/pages/hr/basic/corp/HrBasicCorpTemp.vue')
    },
    {
        path: '/hr_basic_org',
        component: () => import('@/views/pages/hr/basic/org/HrBasicOrg.vue')
    },
    {
        path: '/hr_basic_org_his',
        component: () => import('@/views/pages/hr/basic/org/HrBasicOrgHis.vue')
    },
    {
        path: '/hr_basic_org_temp',
        component: () => import('@/views/pages/hr/basic/org/HrBasicOrgTemp.vue')
    },
    {
        path: '/hr_basic_station',
        component: () => import('@/views/pages/hr/basic/station/HrBasicStation.vue')
    },
    {
        path: '/hr_basic_station_his',
        component: () => import('@/views/pages/hr/basic/station/HrBasicStationHis.vue')
    },
    {
        path: '/hr_basic_station_temp',
        component: () => import('@/views/pages/hr/basic/station/HrBasicStationTemp.vue')
    },
    {
        path: '/hr_adm_compete',
        component: () => import('@/views/pages/hr/adm/compete/HrAdmCompete.vue')
    },
    {
        path: '/hr_adm_compete_score',
        component: () => import('@/views/pages/hr/adm/compete/HrAdmCompeteScore.vue')
    },
    {
        path: '/interviewReplyDetail',
        component: () => import('@/views/pages/hr/adm/compete/interviewReplyDetail.vue')
    },
    {
        path: '/overAllScoreDetail',
        component: () => import('@/views/pages/hr/adm/compete/overAllScoreDetail.vue')
    },
    {
        path: '/writtenTestDetail',
        component: () => import('@/views/pages/hr/adm/compete/writtenTestDetail.vue')
    },
    {
        path: '/hr_adm_cadre',
        component: () => import('@/views/pages/hr/adm/cadre/HrAdmCadre.vue')
    },
    {
        path: '/hr_adm_experte',
        component: () => import('@/views/pages/hr/adm/experte/HrAdmExperte.vue')
    },
    {
        path: '/hr_adm_dispute',
        component: () => import('@/views/pages/hr/adm/dispute/HrAdmDispute.vue')
    },
    {
        path: '/hr_hire_regist_school',
        component: () => import('@/views/pages/hr/hire/regist/HrHireRegistSchool.vue')
    },
    {
        path: '/hr_hire_regist_web',
        component: () => import('@/views/pages/hr/hire/regist/HrHireRegistWeb.vue')
    },
    {
        path: '/hr_hire_regist_work',
        component: () => import('@/views/pages/hr/hire/regist/HrHireRegistWork.vue')
    },
    {
        path: '/hr_hire_regist_plan',
        component: () => import('@/views/pages/hr/hire/regist/HrHireRegistPlan.vue')
    },
    {
        path: '/hr_hire_regist_plan_his',
        component: () => import('@/views/pages/hr/hire/regist/HrHireRegistPlanHis.vue')
    },
    {
        path: '/hr_hire_regist_plan_temp',
        component: () => import('@/views/pages/hr/hire/regist/HrHireRegistPlanTemp.vue')
    },
    {
        path: '/hr_hire_person',
        component: () => import('@/views/pages/hr/basic/eePerson/HrHirePerson.vue')
    },
    {
        path: '/educationExperienceDetail',
        component: () => import('@/views/pages/hr/basic/eePerson/educationExperienceDetail.vue')
    },
    {
        path: '/familyMemberDetail',
        component: () => import('@/views/pages/hr/basic/eePerson/familyMemberDetail.vue')
    },
    {
        path: '/mainSocialDetail',
        component: () => import('@/views/pages/hr/basic/eePerson/mainSocialDetail.vue')
    },
    {
        path: '/trainingExperienceDetail',
        component: () => import('@/views/pages/hr/basic/eePerson/trainingExperienceDetail.vue')
    },
    {
        path: '/workExperienceDetail',
        component: () => import('@/views/pages/hr/basic/eePerson/workExperienceDetail.vue')
    },
    {
        path: '/hr_employee',
        component: () => import('@/views/pages/hr/basic/ee/HrEmployee.vue')
    },
    {
        path: '/hr_employee_regular',
        component: () => import('@/views/pages/hr/basic/eeregular/HrEmployeeRegular.vue')
    },
    {
        path: '/hr_hire_adjust_orgrel',
        component: () => import('@/views/pages/hr/basic/eeadjust/HrHireAdjustOrgrel.vue')
    },
    {
        path: '/hr_employee_leave',
        component: () => import('@/views/pages/hr/basic/eeLeave/HrEmployeeLeave.vue')
    },
    {
        path: '/hr_hire_track',
        component: () => import('@/views/pages/hr/hire/track/HrHireTrack.vue')
    },
    {
        path: '/hr_dossier_info',
        component: () => import('@/views/pages/hr/hire/dossier/HrDossierInfo.vue')
    },
    {
        path: '/HrDossierInfoDetail',
        component: () => import('@/views/pages/hr/hire/dossier/HrDossierInfoDetail.vue')
    },
    {
        path: '/hr_dossier_consult',
        component: () => import('@/views/pages/hr/hire/dossier/HrDossierConsult.vue')
    },
    {
        path: '/hr_dossier_destory',
        component: () => import('@/views/pages/hr/hire/dossier/HrDossierDestory.vue')
    },
    {
        path: '/hr_employee_contract',
        component: () => import('@/views/pages/hr/basic/eeContract/HrEmployeeContract.vue')
    },
    {
        path: '/hr_employee_contract_his',
        component: () => import('@/views/pages/hr/basic/eeContract/HrEmployeeContractHis.vue')
    },
    {
        path: '/hr_employee_contract_temp',
        component: () => import('@/views/pages/hr/basic/eeContract/HrEmployeeContractTemp.vue')
    },
    {
        path: '/hr_train_institute',
        component: () => import('@/views/pages/hr/train/HrTrainInstitute.vue')
    },
    {
        path: '/hr_train_lecturer',
        component: () => import('@/views/pages/hr/train/HrTrainLecturer.vue')
    },
    {
        path: '/hr_train_service_pro',
        component: () => import('@/views/pages/hr/train/HrTrainServicePro.vue')
    },
    {
        path: '/hr_train_plan',
        component: () => import('@/views/pages/hr/train/HrTrainPlan.vue')
    },
    {
        path: '/hr_train_attend',
        component: () => import('@/views/pages/hr/train/HrTrainAttend.vue')
    },
    {
        path: '/HrTrainAttendAbsentList',
        component: () => import('@/views/pages/hr/train/HrTrainAttendAbsentList.vue')
    },
    {
        path: '/HrTrainAttendPresentList',
        component: () => import('@/views/pages/hr/train/HrTrainAttendPresentList.vue')
    },
    {
        path: '/hr_train_satisfy',
        component: () => import('@/views/pages/hr/train/HrTrainSatisfy.vue')
    },
    {
        path: '/HrTrainSatisfyDetail',
        component: () => import('@/views/pages/hr/train/HrTrainSatisfyDetail.vue')
    },
    {
        path: '/hr_train_pro',
        component: () => import('@/views/pages/hr/train/HrTrainPro.vue')
    },
    {
        path: '/hr_train_cert_profession',
        component: () => import('@/views/pages/hr/train/HrTrainCertProfession.vue')
    },
    {
        path: '/hr_train_cert_prac',
        component: () => import('@/views/pages/hr/train/HrTrainCertPrac.vue')
    },
    {
        path: '/hr_train_cert_special',
        component: () => import('@/views/pages/hr/train/HrTrainCertSpecial.vue')
    },
    {
        path: '/hr_perf_daily',
        component: () => import('@/views/pages/hr/perf/daily/HrPerfDaily.vue')
    },
    {
        path: '/hr_perf_charge',
        component: () => import('@/views/pages/hr/perf/charge/HrPerfCharge.vue')
    },
    {
        path: '/hr_perf_promise',
        component: () => import('@/views/pages/hr/perf/promise/HrPerfPromise.vue')
    },
    {
        path: '/HrPerfPromiseDetail',
        component: () => import('@/views/pages/hr/perf/promise/HrPerfPromiseDetail.vue')
    },
    {
        path: '/hr_perf_promise_check',
        component: () => import('@/views/pages/hr/perf/promise/HrPerfPromiseCheck.vue')
    },
    {
        path: '/HrPerfPromiseCheckDetail',
        component: () => import('@/views/pages/hr/perf/promise/HrPerfPromiseCheckDetail.vue')
    },
    {
        path: '/hr_perf_appraise_self',
        component: () => import('@/views/pages/hr/perf/appraise/HrPerfAppraiseSelf.vue')
    },
    {
        path: '/hr_perf_appraise',
        component: () => import('@/views/pages/hr/perf/appraise/HrPerfAppraise.vue')
    },
    {
        path: '/hr_perf_daily_reward',
        component: () => import('@/views/pages/hr/perf/dailyReward/HrPerfDailyReward.vue')
    },
    {
        path: '/hr_salary_regist_holiday',
        component: () => import('@/views/pages/hr/salary/regist/HrSalaryRegistHoliday.vue')
    },
    {
        path: '/hr_salary_weal_heal',
        component: () => import('@/views/pages/hr/salary/corpweal/HrSalaryWealHeal.vue')
    },
    {
        path: '/hr_salary_calc_social',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryCalcSocial.vue')
    },
    {
        path: '/HrSalaryCalcSocialDetail',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryCalcSocialDetail.vue')
    },
    {
        path: '/hr_salary_ins_injury',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryInsInjury.vue')
    },
    {
        path: '/hr_salary_ins_bear',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryInsBear.vue')
    },
    {
        path: '/hr_salary_weal_std',
        component: () => import('@/views/pages/hr/salary/corpweal/HrSalaryWealStd.vue')
    },
    {
        path: '/hr_salary_weal_biz',
        component: () => import('@/views/pages/hr/salary/corpweal/HrSalaryWealBiz.vue')
    },
    {
        path: '/hr_salary_weal_biz_claim',
        component: () => import('@/views/pages/hr/salary/corpweal/HrSalaryWealBizClaim.vue')
    },
    {
        path: '/hr_salary_labor',
        component: () => import('@/views/pages/hr/salary/labor/HrSalaryLabor.vue')
    },
    {
        path: '/hr_salary_labor_fee',
        component: () => import('@/views/pages/hr/salary/labor/HrSalaryLaborFee.vue')
    },
    {
        path: '/hr_employee_retire',
        component: () => import('@/views/pages/hr/salary/retire/HrEmployeeRetire.vue')
    },
    {
        path: '/hr_employee_retire_regist',
        component: () => import('@/views/pages/hr/salary/retire/HrEmployeeRetireRegist.vue')
    },
    {
        path: '/hr_salary_calc_gjj',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryCalcGjj.vue')
    },
    {
        path: '/HrSalaryCalcGjjDetail',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryCalcGjjDetail.vue')
    },
    {
        path: '/hr_adm_appeal',
        component: () => import('@/views/pages/hr/adm/appeal/HrAdmAppeal.vue')
    },
    {
        path: '/HrPerfChargeDetail',
        component: () => import('@/views/pages/hr/perf/charge/HrPerfChargeDetail.vue')
    },
    {
        path: '/hr_salary_calc_actual',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryCalcActual.vue')
    },
    {
        path: '/HrSalaryCalcActualDetail',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryCalcActualDetail.vue')
    },
    {
        path: '/hr_salary_ins_batch',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryInsBatch.vue')
    },
    {
        path: '/HrSalaryInsBatchDetail',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryInsBatchDetail.vue')
    },
    // 企业登记
    {
        path: '/aams_enterprise_reg_approval',
        component: () => import('@/views/pages/aams/enterprise/AamsEnterpriseRegApproval.vue')
    },
    {
        path: '/aams_enterprise_reg_info',
        component: () => import('@/views/pages/aams/enterprise/AamsEnterpriseRegInfo.vue')
    },
    {
        path: '/aams_enterprise_base_category',
        component: () => import('@/views/pages/aams/enterprise/AamsEnterpriseBaseCategory.vue')
    },
    {
        path: '/hr_salary_regist_roster',
        component: () => import('@/views/pages/hr/salary/regist/HrSalaryRegistRoster.vue')
    },
    {
        path: '/hr_salary_regist_workarea',
        component: () => import('@/views/pages/hr/salary/regist/HrSalaryRegistWorkarea.vue')
    },
    {
        path: '/hr_salary_regist_attn',
        component: () => import('@/views/pages/hr/salary/regist/HrSalaryRegistAttnUser.vue')
    },
    {
        path: '/hr_salary_rank_grant',
        component: () => import('@/views/pages/hr/salary/rank/HrSalaryRankGrant.vue')
    },
    {
        path: '/hr_salary_calc_special',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryCalcSpecial.vue')
    },
    {
        path: '/hr_salary_calc_compensate',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryCalcCompensate.vue')
    },
    {
        path: '/hr_salary_calc_leave',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryCalcLeave.vue')
    },
    {
        path: '/HrSalaryCalcLeaveSocialDetail',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryCalcLeaveSocialDetail.vue')
    },
    {
        path: '/HrSalaryCalcLeaveExtraDetail',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryCalcLeaveExtraDetail.vue')
    },
    {
        path: '/hr_employee_bank',
        component: () => import('@/views/pages/hr/salary/calc/HrEmployeeBank.vue')
    },
    {
        path: '/hr_perf_promise_adjust',
        component: () => import('@/views/pages/hr/perf/promise/HrPerfPromiseAdjust.vue')
    },
    {
        path: '/HrPerfPromiseAdjustDetail',
        component: () => import('@/views/pages/hr/perf/promise/HrPerfPromiseAdjustDetail.vue')
    },
    {
        path: '/hr_salary_grant',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryGrant.vue')
    },
    {
        path: '/HrSalaryGrantDetail',
        component: () => import('@/views/pages/hr/salary/calc/HrSalaryGrantDetail.vue')
    },
    {
        path: '/hr_perf_promise_score',
        component: () => import('@/views/pages/hr/perf/promise/HrPerfPromiseScore.vue')
    },
    {
        path: '/HrPerfPromiseScoreDetail',
        component: () => import('@/views/pages/hr/perf/promise/HrPerfPromiseScoreDetail.vue')
    },
    {
        path: '/hr_salary_bonus_theory',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusTheory.vue')
    },
    {
        path: '/HrSalaryBonusTheoryDetail',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusTheoryDetail.vue')
    },
    {
        path: '/hr_salary_bonus_bal',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusBal.vue')
    },
    {
        path: '/HrSalaryBonusBalDetail',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusBalDetail.vue')
    },
    {
        path: '/hr_salary_bonus_tax',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusTax.vue')
    },
    {
        path: '/hr_salary_bonus_actual',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusActual.vue')
    },
    {
        path: '/HrSalaryBonusActualDetail',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusActualDetail.vue')
    },
    {
        path: '/hr_salary_bonus_team',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusTeam.vue')
    },
    {
        path: '/hr_salary_bonus_individ',
        component: () => import('@/views/pages/hr/salary/bonus/HrSalaryBonusIndivid.vue')
    },
    {
        path: '/hr_salary_ins_social',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryInsSocial.vue')
    },
    {
        path: '/hr_salary_ins_social_adjust',
        component: () => import('@/views/pages/hr/salary/socialweal/HrSalaryInsSocialAdjust.vue')
    },
    {
        path: '/sys_dict_value',
        component: () => import('@/views/pages/hr/setting/HrSysDictValue.vue')
    },
    {
        path: '/hr_perf_promise_template',
        component: () => import('@/views/pages/hr/setting/HrPerfPromiseTemplate.vue')
    },
    {
        path: '/hr_param_holiday',
        component: () => import('@/views/pages/hr/setting/HrParamHoliday.vue')
    },
    {
        path: '/hr_param_duty',
        component: () => import('@/views/pages/hr/setting/HrParamDuty.vue')
    },
    {
        path: '/hr_param_percent',
        component: () => import('@/views/pages/hr/setting/HrParamPercent.vue')
    },
    // 资质管理
    {
        path: '/aams_qualification_reg_approval',
        component: () => import('@/views/pages/aams/qualification/AamsQualificationRegApproval.vue')
    },
    {
        path: '/aams_qualification_reg_info',
        component: () => import('@/views/pages/aams/qualification/AamsQualificationRegInfo.vue')
    },
    {
        path: '/aams_qualification_reg_change',
        component: () => import('@/views/pages/aams/qualification/AamsQualificationRegChange.vue')
    },
    // 年检
    {
        path: '/aams_inspection_reg_approval',
        component: () => import('@/views/pages/aams/inspection/AamsInspectionRegApproval.vue')
    },
    {
        path: '/aams_inspection_reg_info',
        component: () => import('@/views/pages/aams/inspection/AamsInspectionRegInfo.vue')
    },
    // 证照
    {
        path: '/aams_license_reg_info',
        component: () => import('@/views/pages/aams/license/AamsLicenseRegInfo.vue')
    },
    {
        path: '/aams_license_reg_usage_approval',
        component: () => import('@/views/pages/aams/license/AamsLicenseRegUsageApproval.vue')
    },
    {
        path: '/aams_license_reg_usage_info',
        component: () => import('@/views/pages/aams/license/AamsLicenseRegUsageInfo.vue')
    },
    {
        path: '/aams_license_reg_estate_info',
        component: () => import('@/views/pages/aams/license/AamsLicenseRegEstateInfo.vue')
    },
    {
        path: '/aams_license_base_category',
        component: () => import('@/views/pages/aams/license/AamsLicenseBaseCategory.vue')
    },
    // 礼物
    {
        path: '/aams_gift_reg_submission',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegSubmission.vue')
    },
    {
        path: '/AamsGiftRegSubmissionDetail',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegSubmissionDetail.vue')
    },
    {
        path: '/aams_gift_reg_purchase_approval',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegPurchaseApproval.vue')
    },
    {
        path: '/aams_gift_reg_in_storage',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegInStorage.vue')
    },
    {
        path: '/AamsGiftRegInStorageDetail',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegInStorageDetail.vue')
    },
    {
        path: '/aams_gift_reg_usage_approval',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegUsageApproval.vue')
    },
    {
        path: '/AamsGiftRegUsageApprovalDetail',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegUsageApprovalDetail.vue')
    },
    {
        path: '/aams_gift_reg_out_storage',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegOutStorage.vue')
    },
    {
        path: '/aams_gift_reg_out_storage_return',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegOutStorageReturn.vue')
    },
    {
        path: '/AamsGiftRegOutStorageReturnDetail',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegOutStorageReturnDetail.vue')
    },
    {
        path: '/aams_gift_reg_inventory_check',
        component: () => import('@/views/pages/aams/gift/AamsGiftRegInventoryCheck.vue')
    },
    {
        path: '/aams_gift_base_category',
        component: () => import('@/views/pages/aams/gift/AamsGiftBaseCategory.vue')
    },
    {
        path: '/aams_gift_base_item',
        component: () => import('@/views/pages/aams/gift/AamsGiftBaseItem.vue')
    },
    // 出差
    {
        path: '/aams_travel_reg_approval',
        component: () => import('@/views/pages/aams/travel/AamsTravelRegApproval.vue')
    },
    {
        path: '/aams_travel_reg_info',
        component: () => import('@/views/pages/aams/travel/AamsTravelRegInfo.vue')
    },
    {
        path: '/aams_travel_base_standard',
        component: () => import('@/views/pages/aams/travel/AamsTravelBaseStandard.vue')
    },
    // 接待
    {
        path: '/aams_reception_reg_approval',
        component: () => import('@/views/pages/aams/reception/AamsReceptionRegApproval.vue')
    },
    {
        path: '/aams_reception_reg_info',
        component: () => import('@/views/pages/aams/reception/AamsReceptionRegInfo.vue')
    },
    {
        path: '/aams_reception_base_standard',
        component: () => import('@/views/pages/aams/reception/AamsReceptionBaseStandard.vue')
    },
    // 投诉
    {
        path: '/aams_complaint_reg_approval',
        component: () => import('@/views/pages/aams/complaint/AamsComplaintRegApproval.vue')
    },
    {
        path: '/aams_complaint_reg_info',
        component: () => import('@/views/pages/aams/complaint/AamsComplaintRegInfo.vue')
    },
    {
        path: '/aams_complaint_base_category',
        component: () => import('@/views/pages/aams/complaint/AamsComplaintBaseCategory.vue')
    },
    // 介绍信
    {
        path: '/aams_letter_usage_approval',
        component: () => import('@/views/pages/aams/letter/AamsLetterUsageApproval.vue')
    },
    {
        path: '/aams_letter_usage_record',
        component: () => import('@/views/pages/aams/letter/AamsLetterUsageRecord.vue')
    },
    // 公文
    {
        path: '/aams_document_reg_dispatch_approval',
        component: () => import('@/views/pages/aams/document/AamsDocumentRegDispatchApproval.vue')
    },
    {
        path: '/aams_document_reg_dispatch_info',
        component: () => import('@/views/pages/aams/document/AamsDocumentRegDispatchInfo.vue')
    },
    {
        path: '/aams_document_reg_receive_info',
        component: () => import('@/views/pages/aams/document/AamsDocumentRegReceiveInfo.vue')
    },
    {
        path: '/aams_document_reg_cancel_approval',
        component: () => import('@/views/pages/aams/document/AamsDocumentRegCancelApproval.vue')
    },
    {
        path: '/aams_document_reg_cancel_info',
        component: () => import('@/views/pages/aams/document/AamsDocumentRegCancelInfo.vue')
    },
    {
        path: '/aams_document_base_category',
        component: () => import('@/views/pages/aams/document/AamsDocumentBaseCategory.vue')
    },
    {
        path: '/aams_document_base_dispatch_code',
        component: () => import('@/views/pages/aams/document/AamsDocumentBaseDispatchCode.vue')
    },
    // 授权委托
    {
        path: '/lams_auth_reg_approval',
        component: () => import('@/views/pages/lams/auth/lamsAuthRegApproval.vue')
    },
    {
        path: '/lams_auth_reg_record',
        component: () => import('@/views/pages/lams/auth/lamsAuthRegRecord.vue')
    },
    {
        path: '/lams_auth_reg_accident_record',
        component: () => import('@/views/pages/lams/auth/lamsAuthRegAccidentRecord.vue')
    },
    {
        path: '/lams_auth_base_accident_category',
        component: () => import('@/views/pages/lams/auth/lamsAuthBaseAccidentCategoryApproval.vue')
    },
    {
        path: '/lams_auth_base_category',
        component: () => import('@/views/pages/lams/auth/lamsAuthBaseCategoryApproval.vue')
    },
    // 档案
    {
        path: '/arms_reg_archive_approval',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveApproval.vue')
    },
    {
        path: '/arms_reg_archive_filing_info',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveFilingInfo.vue')
    },
    {
        path: '/ArmsRegArchiveFillingInfoDetail',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveFillingInfoDetail.vue')
    },
    {
        path: '/ArmsRegArchiveFillingInfoFile',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveFillingInfoFile.vue')
    },
    {
        path: '/arms_reg_archive_usage_info',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveUsageInfo.vue')
    },
    {
        path: '/arms_reg_archive_return_info',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveReturnInfo.vue')
    },
    {
        path: '/arms_reg_archive_loss_info',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveLossInfo.vue')
    },
    {
        path: '/arms_reg_archive_completion_info',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveCompletionInfo.vue')
    },
    {
        path: '/arms_base_archive_catalog',
        component: () => import('@/views/pages/aams/arms/ArmsBaseArchiveCatalog.vue')
    },
    {
        path: '/arms_base_archive_category',
        component: () => import('@/views/pages/aams/arms/ArmsBaseArchiveCategory.vue')
    },
    {
        path: '/arms_base_archive_filing_reference',
        component: () => import('@/views/pages/aams/arms/ArmsBaseArchiveFilingReference.vue')
    },
    {
        path: '/arms_base_archive_location',
        component: () => import('@/views/pages/aams/arms/ArmsBaseArchiveLocation.vue')
    },
    {
        path: '/arms_base_confidential_level',
        component: () => import('@/views/pages/aams/arms/ArmsBaseConfidentialLevel.vue')
    },
    {
        path: '/arms_base_project_catalog',
        component: () => import('@/views/pages/aams/arms/ArmsBaseProjectCatalog.vue')

    },
    {
        path: '/arms_reg_archive_destruction_info',
        component: () => import('@/views/pages/aams/arms/ArmsRegArchiveDestructionInfo.vue')

    },
    // 业务单位
    {
        path: '/aams_unit_base_nature',
        component: () => import('@/views/pages/aams/unit/AamsUnitBaseNature.vue')
    },
    {
        path: '/aams_unit_base_category',
        component: () => import('@/views/pages/aams/unit/AamsUnitBaseCategory.vue')
    },
    {
        path: '/aams_unit_reg_info',
        component: () => import('@/views/pages/aams/unit/AamsUnitRegInfo.vue')
    },
    {
        path: '/AamsUnitRegInfoBankDetail',
        component: () => import('@/views/pages/aams/unit/AamsUnitRegInfoBankDetail.vue')
    },
    {
        path: '/AamsUnitRegInfoContactDetail',
        component: () => import('@/views/pages/aams/unit/AamsUnitRegInfoContactDetail.vue')
    },
    {
        path: '/aams_unit_reg_usage_approval',
        component: () => import('@/views/pages/aams/unit/AamsUnitRegUsageApproval.vue')
    },
    // 后勤管理
    {
        path: '/hqgl_zc_base_class',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsBaseClass.vue')
    },
    {
        path: '/hqgl_zc_base_variety',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsBaseVariety.vue')
    },
    {
        path: '/hqgl_zc_base_code_rules',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsBaseCodeRules.vue')
    },
    {
        path: '/hqgl_zc_gouzhi_main',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsPayAudit.vue')
    },
    {
        path: '/hqgl_zc_inputmain',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsInbound.vue')
    },
    {
        path: '/hqglLogisticsInboundDetail',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsInboundDetail.vue')
    },
    // swzc 剩余
    {
        path: '/hqgl_zc_chuzhisp',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsDispose.vue')
    },
    {
        path: '/hqglLogisticsDisposeDetail',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsDisposeDetail.vue')
    },
    {
        path: '/hqgl_zc_chuzhi_info',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsDisposeInfo.vue')
    },
    {
        path: '/hqgl_zc_fixregmain',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsFix.vue')
    },
    {
        path: '/hqgl_zc_fixattach_main',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsFixAttach.vue')
    },
    {
        path: '/hqglLogisticsFixAttachDetail',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsFixAttachDetail.vue')
    },
    {
        path: '/hqglLogisticsFixDetail',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsFixDetail.vue')
    },
    {
        path: '/hqgl_zc_pandian_x',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsInventory.vue')
    },
    {
        path: '/hqgl_zc_item_sale',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsItemSale.vue')
    },
    {
        path: '/hqgl_zc_item_sale_info',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsItemSaleInfo.vue')
    },
    {
        path: '/hqgl_zc_transfers',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsTransfer.vue')
    },
    {
        path: '/hqglLogisticsTransferDetail',
        component: () => import('@/views/pages/hqgl/swzc/hqglLogisticsTransferDetail.vue')
    },
    {
        path: '/hqgl_zc_jiaofureg_main',
        component: () => import('@/views/pages/hqgl/swzc/hqglZcJIaofuregMain.vue')
    },
    {
        path: '/hqglZcJIaofuregMainDetail',
        component: () => import('@/views/pages/hqgl/swzc/hqglZcJIaofuregMainDetail.vue')
    },
    {
        path: '/hqgl_zc_jiaofusp_main',
        component: () => import('@/views/pages/hqgl/swzc/hqglZcJIaofuspMain.vue')
    },
    {
        path: '/hqglZcJIaofuspMainDetail',
        component: () => import('@/views/pages/hqgl/swzc/hqglZcJIaofuspMainDetail.vue')
    },
    // 福利
    {
        path: '/hqgl_item_benefits_class',
        component: () => import('@/views/pages/hqgl/benefits/hqglBenefitsClass.vue')
    },
    {
        path: '/hqgl_item_benefits_fee',
        component: () => import('@/views/pages/hqgl/benefits/hqglBenefitsFee.vue')
    },
    {
        path: '/hqgl_item_benefits_grant_audit',
        component: () => import('@/views/pages/hqgl/benefits/hqglBenefitsGrantAudit.vue')
    },
    {
        path: '/hqglBenefitsGrantAuditDetail',
        component: () => import('@/views/pages/hqgl/benefits/hqglBenefitsGrantAuditDetail.vue')
    },
    {
        path: '/hqgl_item_benefits_procure_fee',
        component: () => import('@/views/pages/hqgl/benefits/hqglBenefitsProcureFee.vue')
    },
    // 食堂
    {
        path: '/hqgl_canteen_base_fee_name',
        component: () => import('@/views/pages/hqgl/canteen/hqglCanteenBaseFeeName.vue')
    },
    {
        path: '/hqgl_canteen_fee',
        component: () => import('@/views/pages/hqgl/canteen/hqglCanteenFee.vue')
    },
    {
        path: '/hqglCanteenFeeDetail',
        component: () => import('@/views/pages/hqgl/canteen/hqglCanteenFeeDetail.vue')
    },
    {
        path: '/hqgl_canteen_grant_fee',
        component: () => import('@/views/pages/hqgl/canteen/hqglCanteenGrantFee.vue')
    },
    // 车辆
    {
        path: '/aams_car_base_insurance',
        component: () => import('@/views/pages/hqgl/car/hqglCarBaseInsurance.vue')
    },
    {
        path: '/hqgl_car_fee_subsidy',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegBenefitApproval.vue')
    },
    {
        path: '/hqgl_car_fee_subsidy_info',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegBenefitInfo.vue')
    },
    {
        path: '/hqgl_car_fee_standard',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegBenefitStandard.vue')
    },
    {
        path: '/hqgl_company_car_borrow_audit',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegBorrowApproval.vue')
    },
    {
        path: '/hqgl_company_car_borrow_info',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegBorrowInfo.vue')
    },
    {
        path: '/aams_car_reg_car',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegCar.vue')
    },
    {
        path: '/hqgl_car_reg_card_recharge',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegCardRecharge.vue')
    },
    {
        path: '/hqgl_company_car_claims',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegClaim.vue')
    },
    {
        path: '/hqgl_company_car_daily_fee',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegDailyFee.vue')
    },
    {
        path: '/hqgl_company_car_use_info',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegDraw.vue')
    },
    {
        path: '/hqgl_company_car_insurance_fee',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegInsuranceFee.vue')
    },
    {
        path: '/hqglCarRegInsuranceFeeDetail',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegInsuranceFeeDetail.vue')
    },
    {
        path: '/hqgl_company_car_fix_audit',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegMaintainApproval.vue')
    },
    {
        path: '/hqgl_company_car_fix_info',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegMaintainInfo.vue')
    },
    {
        path: '/hqglCarRegMaintainInfoDetail',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegMaintainInfoDetail.vue')
    },
    {
        path: '/hqgl_company_data_storage',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegMaterialKeep.vue')
    },
    {
        path: '/hqgl_company_car_hygiene_check',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegSanitationCheck.vue')
    },
    {
        path: '/hqgl_company_car_card_recharge',
        component: () => import('@/views/pages/hqgl/car/hqglCarRegYearAudit.vue')
    },
    // 电脑网络
    {
        path: '/hqgl_computer_network_info',
        component: () => import('@/views/pages/hqgl/computerNetwork/hqglBaseComputerCheck.vue')
    },
    {
        path: '/hqgl_base_computer_setting',
        component: () => import('@/views/pages/hqgl/computerNetwork/hqglBaseComputerSetting.vue')
    },
    {
        path: '/hqgl_computer_use_info',
        component: () => import('@/views/pages/hqgl/computerNetwork/hqglComputerUsageInfo.vue')
    },
    // 邮件
    {
        path: '/hqgl_mail_receive_info',
        component: () => import('@/views/pages/hqgl/mail/hqglMailReceiveInfo.vue')
    },
    {
        path: '/hqgl_mail_send_audit',
        component: () => import('@/views/pages/hqgl/mail/hqglMailSendAudit.vue')
    },
    {
        path: '/hqgl_mail_send_info',
        component: () => import('@/views/pages/hqgl/mail/hqglMailSendInfo.vue')
    },
    // 办公规章
    {
        path: '/hqgl_office_rules_electric_fee',
        component: () => import('@/views/pages/hqgl/officeRules/hqglOfficeRulesElectricFee.vue')
    },
    {
        path: '/hqgl_office_base_rules_fee',
        component: () => import('@/views/pages/hqgl/officeRules/hqglOfficeRulesFee.vue')
    },
    {
        path: '/hqgl_office_base_rules_fee_place',
        component: () => import('@/views/pages/hqgl/officeRules/hqglOfficeRulesFeePlace.vue')
    },
    {
        path: '/hqgl_office_rules_water_fee',
        component: () => import('@/views/pages/hqgl/officeRules/hqglOfficeRulesWaterFee.vue')
    },
    {
        path: '/hqgl_office_rules_wuye_fee',
        component: () => import('@/views/pages/hqgl/officeRules/hqglOfficeRulesWuyeFee.vue')
    },
    // 办公
    {
        path: '/hqgl_office_base_board_style',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeBaseBoardStyle.vue')
    },
    {
        path: '/hqgl_office_base_door_style',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeBaseDoorStyle.vue')
    },
    {
        path: '/hqgl_office_base_furniture',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeBaseFurniture.vue')
    },
    {
        path: '/hqgl_office_base_holiday',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeBaseHoliday.vue')
    },
    {
        path: '/hqgl_office_base_info',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeBaseInfo.vue')
    },
    {
        path: '/hqgl_office_door_make',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeDoorMake.vue')
    },
    {
        path: '/hqgl_office_key_info',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeKeyInfo.vue')
    },
    {
        path: '/hqgl_office_key_make_info',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeKeyMakeInfo.vue')
    },
    {
        path: '/hqgl_office_key_receive_audit',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeKeyReceiveAudit.vue')
    },
    {
        path: '/hqgl_office_key_receive_info',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeKeyReceiveInfo.vue')
    },
    {
        path: '/hqgl_office_notice_content',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeNoticeContent.vue')
    },
    {
        path: '/hqgl_office_visitor_reception',
        component: () => import('@/views/pages/hqgl/office/hqglOfficeVisitorReception.vue')
    },
    // 电话
    {
        path: '/hqgl_tel_fee_detail',
        component: () => import('@/views/pages/hqgl/tel/hqglTelDetailFee.vue')
    },
    {
        path: '/hqgl_tel_setup_app',
        component: () => import('@/views/pages/hqgl/tel/hqglTelSetupApp.vue')
    },
    {
        path: '/hqgl_tel_setup_reg',
        component: () => import('@/views/pages/hqgl/tel/hqglTelSetupReg.vue')
    },
    // 工作
    {
        path: '/hqgl_work_lunch',
        component: () => import('@/views/pages/hqgl/work/hqglWorkLunch.vue')
    },
    // 工作日志
    {
        path: '/erpLogin',
        component: () => import('@/views/erpLogin.vue'),
        meta: {title: '工作日志'}
    },
    {
        path: '/dailyLog/index',
        component: () => import('@/views/pages/dailyLog/index.vue')
    },
    {
        path: '/dailyLog/edit',
        component: () => import('@/views/pages/dailyLog/edit.vue')
    },
    {
        path: '/dailyLog/detail',
        component: () => import('@/views/pages/dailyLog/detail.vue')
    },
    //农业管理系统
    {
        path: '/apms_basic_plant_protection_batch_setting',
        component: () => import('@/views/pages/apms/basic/ApmsBasicPlantProtectionBatchSetting.vue')
    },
    {
        path: '/apms_basic_phenophase_category',
        component: () => import('@/views/pages/apms/basic/ApmsBasicPhenophaseCategory.vue')
    },
    {
        path: '/apms_basic_farming_category',
        component: () => import('@/views/pages/apms/basic/ApmsBasicFarmingCategory.vue')
    },
    {
        path: '/apms_basic_canteen_material_category',
        component: () => import('@/views/pages/apms/basic/ApmsBasicCanteenMaterialCategory.vue')
    },
    {
        path: '/apms_basic_image_library_category',
        component: () => import('@/views/pages/apms/basic/ApmsBasicImageLibraryCategory.vue')
    },
    {
        path: '/apms_basic_plot_info',
        component: () => import('@/views/pages/apms/basic/ApmsBasicPlotInfo.vue')
    },
    {
        path: '/apms_basic_planting_info',
        component: () => import('@/views/pages/apms/basic/ApmsBasicPlantInfo.vue')
    },
    {
        path: '/apms_basic_phenophase_info',
        component: () => import('@/views/pages/apms/basic/ApmsBasicPhenophaseInfo.vue')
    },
    {
        path: '/apms_basic_farming_operation',
        component: () => import('@/views/pages/apms/basic/ApmsBasicFarmingOperation.vue')
    },
    {
        path: '/apms_basic_canteen_material_info',
        component: () => import('@/views/pages/apms/basic/ApmsBasicCanteenMaterialInfo.vue')
    },
    {
        path: '/apms_basic_labor_team',
        component: () => import('@/views/pages/apms/basic/ApmsBasicLaborTeam.vue')
    },
    {
        path: '/apms_basic_image_library_info',
        component: () => import('@/views/pages/apms/basic/ApmsBasicImageLibraryInfo.vue')
    },
    {
        path: '/apms_basic_tool_info',
        component: () => import('@/views/pages/apms/basic/ApmsBasicToolInfo.vue')
    },
    {
        path: '/apms_reg_plant_protection_info',
        component: () => import('@/views/pages/apms/reg/ApmsRegPlantProtectionInfo.vue')
    },
    {
        path: '/ApmsRegPlantProtectionInfoDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegPlantProtectionInfoDetail.vue')
    },
    {
        path: '/ApmsRegPlantProtectionInfoDetail2',
        component: () => import('@/views/pages/apms/reg/ApmsRegPlantProtectionInfoDetail2.vue')
    },
    {
        path: '/apms_reg_farming_info',
        component: () => import('@/views/pages/apms/reg/ApmsRegFarmingInfo.vue')
    },
    {
        path: '/apms_reg_labor_employment',
        component: () => import('@/views/pages/apms/reg/ApmsRegLaborEmployment.vue')
    },
    {
        path: '/apms_reg_thinning_bagging',
        component: () => import('@/views/pages/apms/reg/ApmsRegThinningBagging.vue')
    },
    {
        path: '/apms_reg_canteen_purchase',
        component: () => import('@/views/pages/apms/reg/ApmsRegCanteenPurchase.vue')
    },
    {
        path: '/apms_reg_canteen_requisition',
        component: () => import('@/views/pages/apms/reg/ApmsRegCanteenRequisition.vue')
    },
    {
        path: '/apms_reg_utility_bill',
        component: () => import('@/views/pages/apms/reg/ApmsRegUtilityBill.vue')
    },
    {
        path: '/apms_reg_annual_yield_forecast',
        component: () => import('@/views/pages/apms/reg/ApmsRegAnnualYieldForecast.vue')
    },
    {
        path: '/apms_reg_tool_in_record',
        component: () => import('@/views/pages/apms/reg/ApmsRegToolInRecord.vue')
    },
    {
        path: '/apms_reg_tool_out_record',
        component: () => import('@/views/pages/apms/reg/ApmsRegToolOutRecord.vue')
    },
    {
        path: '/apms_reg_tool_return_record',
        component: () => import('@/views/pages/apms/reg/ApmsRegToolReturnRecord.vue')
    },
    {
        path: '/apms_reg_tool_lease',
        component: () => import('@/views/pages/apms/reg/ApmsRegToolLease.vue')
    },
    {
        path: '/ApmsRegToolLeaseDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegToolLeaseDetail.vue')
    },
    {
        path: '/apms_reg_contract_settlement',
        component: () => import('@/views/pages/apms/reg/ApmsRegContractSettlement.vue')
    },
    {
        path: '/ApmsRegContractSettlementBusinessDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegContractSettlementBusinessDetail.vue')
    },
    {
        path: '/ApmsRegContractSettlementSummaryDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegContractSettlementSummaryDetail.vue')
    },
    {
        path: '/ApmsRegFarmingInfoDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegFarmingInfoDetail.vue')
    },
    {
        path: '/ApmsRegLaborEmploymentDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegLaborEmploymentDetail.vue')
    },
    {
        path: '/ApmsRegThinningBaggingDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegThinningBaggingDetail.vue')
    },
    {
        path: '/ApmsRegCanteenPurchaseDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegCanteenPurchaseDetail.vue')
    },
    {
        path: '/ApmsRegCanteenRequisitionDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegCanteenRequisitionDetail.vue')
    },
    {
        path: '/ApmsRegUtilityBillDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegUtilityBillDetail.vue')
    },
    {
        path: '/ApmsRegAnnualYieldForecastDetail',
        component: () => import('@/views/pages/apms/reg/ApmsRegAnnualYieldForecastDetail.vue')
    },
    // {
    //     path: '/cbSubTableDetail',
    //     component: () => import('@/views/pages/chengben/contract/component/SubTableDetail.vue')
    // },
    // // 成本管理-合同审批
    // {
    //     path: '/cb_contract',
    //     component: () => import('@/views/pages/chengben/contract/contract-mobile.vue')
    // },
    // {
    //     path: '/cb_request',
    //     component: () => import('@/views/pages/chengben/contract/request-mobile.vue')
    // },
    // {
    //     path: '/cb_payment',
    //     component: () => import('@/views/pages/chengben/contract/payment-mobile.vue')
    // },
    // {
    //     path: '/cb_settlement',
    //     component: () => import('@/views/pages/chengben/contract/settlement-mobile.vue')
    // },
    // {
    //     path: '/cb_invoice',
    //     component: () => import('@/views/pages/chengben/contract/invoice-mobile.vue')
    // },
    // {
    //     path: '/cb_fee',
    //     component: () => import('@/views/pages/chengben/contract/fee-mobile.vue')
    // },
    // {
    //     path: '/cb_deduction',
    //     component: () => import('@/views/pages/chengben/contract/deduction-mobile.vue')
    // },
    // {
    //     path: '/cb_reward',
    //     component: () => import('@/views/pages/chengben/contract/reward-mobile.vue')
    // },
    // {
    //     path: '/cb_warranty',
    //     component: () => import('@/views/pages/chengben/contract/warranty-mobile.vue')
    // },
    // {
    //     path: '/cb_visa_apply',
    //     component: () => import('@/views/pages/chengben/contract/visa-apply-mobile.vue')
    // },
    // {
    //     path: '/cb_visa_confirm',
    //     component: () => import('@/views/pages/chengben/contract/visa-confirm-mobile.vue')
    // },
    // {
    //     path: '/cb_design_apply',
    //     component: () => import('@/views/pages/chengben/contract/design-apply-mobile.vue')
    // },
    // {
    //     path: '/cb_design_confirm',
    //     component: () => import('@/views/pages/chengben/contract/design-confirm-mobile.vue')
    // },
    // {
    //     path: '/cb_adjust_plan',
    //     component: () => import('@/views/pages/chengben/contract/adjust-plan-mobile.vue')
    // },
    // {
    //     path: '/cb_adjust_material',
    //     component: () => import('@/views/pages/chengben/contract/adjust-material-mobile.vue')
    // },
    // {
    //     path: '/cb_unusual',
    //     component: () => import('@/views/pages/chengben/contract/unusual-mobile.vue')
    // },
    // // 成本管理-成交审批
    // {
    //     path: '/cb_deal_approval',
    //     component: () => import('@/views/pages/chengben/deal/deal-approval-mobile.vue')
    // },
    // {
    //     path: '/cb_change_house',
    //     component: () => import('@/views/pages/chengben/deal/change-house-mobile.vue')
    // },
    // {
    //     path: '/cb_change_discount',
    //     component: () => import('@/views/pages/chengben/deal/change-discount-mobile.vue')
    // },
    // {
    //     path: '/cb_change_payment',
    //     component: () => import('@/views/pages/chengben/deal/change-payment-mobile.vue')
    // },
    // {
    //     path: '/cb_deal_change_name',
    //     component: () => import('@/views/pages/chengben/deal/deal-change-name-mobile.vue')
    // },
    // {
    //     path: '/cb_deal_return',
    //     component: () => import('@/views/pages/chengben/deal/deal-return-mobile.vue')
    // },
    // {
    //     path: '/cb_building_price',
    //     component: () => import('@/views/pages/chengben/deal/building-price-mobile.vue')
    // },
    // {
    //     path: '/cb_delay_signing',
    //     component: () => import('@/views/pages/chengben/deal/delay-signing-mobile.vue')
    // },
    // {
    //     path: '/cb_receivable_refund',
    //     component: () => import('@/views/pages/chengben/deal/receivable-refund-mobile.vue')
    // },
    // // 成本管理-材料审批
    // {
    //     path: '/cb_put_storehouse',
    //     component: () => import('@/views/pages/chengben/material/CbPutStorehouse.vue')
    // },
    // {
    //     path: '/cb_warehousing_approval',
    //     component: () => import('@/views/pages/chengben/material/CbWarehousingApproval.vue')
    // },
    // {
    //     path: '/cb_receipt_view',
    //     component: () => import('@/views/pages/chengben/material/CbReceiptView.vue')
    // },
    // {
    //     path: '/cb_requirement_view',
    //     component: () => import('@/views/pages/chengben/material/CbRequirementView.vue')
    // },
    // {
    //     path: '/cb_matercontract_view',
    //     component: () => import('@/views/pages/chengben/material/CbMaterContractView.vue')
    // },
    // {
    //     path: '/cb_material_delivery',
    //     component: () => import('@/views/pages/chengben/material/CbMaterialDelivery.vue')
    // },
    // {
    //     path: '/cb_material_invoice',
    //     component: () => import('@/views/pages/chengben/material/CbMaterialInvoice.vue')
    // },
    // {
    //     path: '/cb_picking_detail',
    //     component: () => import('@/views/pages/chengben/material/CbPickingDetail.vue')
    // },
    // {
    //     path: '/cb_party_a_material_add',
    //     component: () => import('@/views/pages/chengben/material/CbPartyAMaterialAdd.vue')
    // },
    // // 成本管理-供应商审批
    // {
    //     path: '/cb_supplier_info',
    //     component: () => import('@/views/pages/chengben/supplier/CbSupplierInfo.vue')
    // },
    // {
    //     path: '/cb_supplier_black',
    //     component: () => import('@/views/pages/chengben/supplier/CbSupplierBlack.vue')
    // },
    // {
    //     path: '/cb_supplier_change',
    //     component: () => import('@/views/pages/chengben/supplier/CbSupplierChange.vue')
    // },
    // {
    //     path: '/cb_supplier_conformity',
    //     component: () => import('@/views/pages/chengben/supplier/CbSupplierConformity.vue')
    // },
    // // 成本管理-排号审批
    // {
    //     path: '/cb_queue_number',
    //     component: () => import('@/views/pages/chengben/queue-number/CbQueueNumber.vue')
    // },
    // {
    //     path: '/cb_queue_rename',
    //     component: () => import('@/views/pages/chengben/queue-number/CbQueueRename.vue')
    // },
    // {
    //     path: '/cb_queue_return',
    //     component: () => import('@/views/pages/chengben/queue-number/CbQueueReturn.vue')
    // }
    // 企业文化
    {
        path: '/culture_asset_base_class',
        component: () => import('@/views/pages/culture/asset/CultureAssetBaseClass.vue')
    },
    {
        path: '/culture_asset_purchase_audit',
        component: () => import('@/views/pages/culture/asset/CultureAssetPurchaseAudit.vue')
    },
    {
        path: '/culture_asset_purchase_info',
        component: () => import('@/views/pages/culture/asset/CultureAssetPurchaseInfo.vue')
    },
    {
        path: '/culture_asset_register_audit',
        component: () => import('@/views/pages/culture/asset/CultureAssetRegisterAudit.vue')
    },
    {
        path: '/culture_asset_register_info',
        component: () => import('@/views/pages/culture/asset/CultureAssetRegisterInfo.vue')
    },
    {
        path: '/culture_asset_delivery_audit',
        component: () => import('@/views/pages/culture/asset/CultureAssetDeliveryAudit.vue')
    },
    {
        path: '/culture_asset_delivery_info',
        component: () => import('@/views/pages/culture/asset/CultureAssetDeliveryInfo.vue')
    },
    {
        path: '/culture_asset_maintain_audit',
        component: () => import('@/views/pages/culture/asset/CultureAssetMaintainAudit.vue')
    },
    {
        path: '/culture_asset_maintain_info',
        component: () => import('@/views/pages/culture/asset/CultureAssetMaintainInfo.vue')
    },
    {
        path: '/culture_asset_utilize_audit',
        component: () => import('@/views/pages/culture/asset/CultureAssetUtilizeAudit.vue')
    },
    {
        path: '/culture_asset_utilize_info',
        component: () => import('@/views/pages/culture/asset/CultureAssetUtilizeInfo.vue')
    },
    {
        path: '/culture_asset_dispose_audit',
        component: () => import('@/views/pages/culture/asset/CultureAssetDisposeAudit.vue')
    },
    {
        path: '/culture_asset_dispose_info',
        component: () => import('@/views/pages/culture/asset/CultureAssetDisposeInfo.vue')
    },
    {
        path: '/culture_activity_audit',
        component: () => import('@/views/pages/culture/activity/CultureActivityAudit.vue')
    },
    {
        path: '/culture_activity_holiday_type',
        component: () => import('@/views/pages/culture/activity/CultureActivityHolidayType.vue')
    },
    {
        path: '/culture_activity_info',
        component: () => import('@/views/pages/culture/activity/CultureActivityInfo.vue')
    },
    {
        path: '/culture_activity_type',
        component: () => import('@/views/pages/culture/activity/CultureActivityType.vue')
    },
    {
        path: '/culture_about_jinqiao_content_okay_audit',
        component: () => import('@/views/pages/culture/about/CultureAboutJinqiaoContentOkayAudit.vue')
    },
    {
        path: '/culture_about_jinqiao_content_use_audit',
        component: () => import('@/views/pages/culture/about/CultureAboutJinqiaoContentUseAudit.vue')
    },
    {
        path: '/culture_about_jinqiao_form_type',
        component: () => import('@/views/pages/culture/about/CultureAboutJinqiaoFormType.vue')
    },
    {
        path: '/culture_about_jinqiao_type',
        component: () => import('@/views/pages/culture/about/CultureAboutJinqiaoType.vue')
    },
    {
        path: '/culture_design_material_borrow_audit',
        component: () => import('@/views/pages/culture/design/CultureDesignMaterialBorrowAudit.vue')
    },
    {
        path: '/culture_design_material_borrow_info',
        component: () => import('@/views/pages/culture/design/CultureDesignMaterialBorrowInfo.vue')
    },
    {
        path: '/culture_design_material_inbound_info',
        component: () => import('@/views/pages/culture/design/CultureDesignMaterialInboundInfo.vue')
    },
    {
        path: '/culture_design_material_procurement_audit',
        component: () => import('@/views/pages/culture/design/CultureDesignMaterialProcurementAudit.vue')
    },
    {
        path: '/culture_design_material_type',
        component: () => import('@/views/pages/culture/design/CultureDesignMaterialType.vue')
    },
    {
        path: '/culture_design_material_year_info',
        component: () => import('@/views/pages/culture/design/CultureDesignMaterialYearInfo.vue')
    },
    {
        path: '/culture_new_media_post_audit',
        component: () => import('@/views/pages/culture/newmedia/CultureNewMediaPostAudit.vue')
    },
    {
        path: '/culture_new_media_post_info',
        component: () => import('@/views/pages/culture/newmedia/CultureNewMediaPostInfo.vue')
    },
    {
        path: '/culture_new_media_register_audit',
        component: () => import('@/views/pages/culture/newmedia/CultureNewMediaRegisterAudit.vue')
    },
    {
        path: '/culture_new_media_register_info',
        component: () => import('@/views/pages/culture/newmedia/CultureNewMediaRegisterInfo.vue')
    },
    {
        path: '/culture_promotion_content_post_audit',
        component: () => import('@/views/pages/culture/promotion/CulturePromotionContentPostAudit.vue')
    },
    {
        path: '/culture_promotion_content_post_info',
        component: () => import('@/views/pages/culture/promotion/CulturePromotionContentPostInfo.vue')
    },
    {
        path: '/culture_promotion_content_type',
        component: () => import('@/views/pages/culture/promotion/CulturePromotionContentType.vue')
    },
    {
        path: '/culture_promotion_form_type',
        component: () => import('@/views/pages/culture/promotion/CulturePromotionFormType.vue')
    },
    {
        path: '/culture_promotion_platform_type',
        component: () => import('@/views/pages/culture/promotion/CulturePromotionPlatformType.vue')
    },
    {
        path: '/culture_vi_image_abolish_audit',
        component: () => import('@/views/pages/culture/vi/CultureViImageAbolishAudit.vue')
    },
    {
        path: '/culture_vi_image_abolish_info',
        component: () => import('@/views/pages/culture/vi/CultureViImageAbolishInfo.vue')
    },
    {
        path: '/culture_vi_image_app_type',
        component: () => import('@/views/pages/culture/vi/CultureViImageAppType.vue')
    },
    {
        path: '/culture_vi_image_design_audit',
        component: () => import('@/views/pages/culture/vi/CultureViImageDesignAudit.vue')
    },
    {
        path: '/culture_vi_image_design_info',
        component: () => import('@/views/pages/culture/vi/CultureViImageDesignInfo.vue')
    },
    {
        path: '/culture_vi_image_register_audit',
        component: () => import('@/views/pages/culture/vi/CultureViImageRegisterAudit.vue')
    },
    {
        path: '/culture_vi_image_register_info',
        component: () => import('@/views/pages/culture/vi/CultureViImageRegisterInfo.vue')
    },
    {
        path: '/culture_vi_image_type',
        component: () => import('@/views/pages/culture/vi/CultureViImageType.vue')
    },
]
const router = new Router({
    mode: 'hash',
    base: '/api',
    routes,
    // query: {
    //   dd_orientation:'landscape',
    //   dd_nav_bgcolor:'FF5E97F6'
    // }
})

export default router
